import { useState, useEffect, useRef, useContext } from "react";
import { Box, RadioButtonGroup, Select, Text, Button, Form, TextInput, 
        Layer, Header, Image, Card, ResponsiveContext, Menu, DropButton,} from "grommet";
import { Search, Edit, FormEdit, FormClose, DocumentExcel,  Previous, Next, 
        Checkmark, FormCheckmark, Certificate, CheckboxSelected, StatusInfo, Trash, FormTrash } from "grommet-icons";
import { useFetch } from "use-http";
import { useNavigate, useLocation } from "react-router-dom";
import WarningPopupWindow from "../Base components/WarningPopupWindow";
import DangerPopupWindow from "../Base components/DangerPopupWindow";
import { isValidYearString, getDBURL, generateSyncId, convertDateToDisplayformat, sheetStatus, 
        correctTimeZone, extractYearFromDateISOString, usePopupFocus } from "../Utils/Utils";
import { getPhenologicalPhaseOptions, getLabelByIndex, } from "../Utils/RBGUtils";
import Field from "../Base components/Field";
import SeedlingOnField from "../Base components/SeedlingOnField";
import ScionOnField from "../Base components/ScionOnField";
import StationList from  "../Base components/StationList";
// import StationTreatmentsButtons from  "../Base components/StationTreatmentsButtons";
// import AddingStationsToField from  "../Base components/AddingStationsToField";
import { useDataContext } from '../Contexts/DataContext';
import { UserContext } from "../../App";
import StationPopup from "../Base components/StationPopup";
import TreatmentsListByStation from "../Base components/TreatmentsListByStation";
import AddNewSeedling from "../Base components/AddNewSeedling";
import AddScionsToTreatmentPopup from "../Base components/AddScionsToTreatmentPopup";
import ParentsListWindow from "../Base components/ParentsListWindow";
import ChangePhenologicalPhaseDate from "../Base components/ChangePhenologicalPhaseDate";
import StationCharacteristicsPopup from "../Base components/StationCharacteristicsPopup";
import CultivarDetails from '../Cultivars/CultivarDetails';
import DropdownMenu from "../Base components/DropdownMenu";
import ExpandingButtonsMenu from "../Base components/ExpandingButtonsMenu";
import StationMultiYearSummary from "../Base components/StationMultiYearSummary";
import Notification from "../Base components/Notification";
import { useErrorLogger } from '../Base components/Logger';

// pop-up window for entering the year for scions without treatment
const AddScionsWithoutTreatmentPopup = (props)=>{
    const [error, setError]= useState('');
    const [disable, setDisable]= useState(false);

    useEffect(() => {
        setDisable(false);
        setError('');
        if ( props.year !== null && props.year.toString().length !== 4)
        {
            setError("Year should be at least 4 digits long");  
            setDisable(true);
        }

        if (props.year === '' || props.year === null)
        {
            setError("Year can't be empty");
            setDisable(true);
        }             
    }, [props.year, disable])


    return (
        <Layer
            id="alertmsg"
            position="center"
            background="light-3"
        >
            <Box pad="small" margin="small" gap="small" width="medium" >

                <Box style={{position:"relative"}}>
                    <Header margin="none" background="light-4" pad="small" height="xxsmall" justify="around">
                        <Text alignSelf="start" color="brand" size="large"  align="center" >
                            <strong>Confirm</strong>
                        </Text>
                    </Header>
                    <Box height="xsmall" width="xsmall"
                        style={{position:"absolute", right: "3%", top: "15px"}}
                        right="0px"
                        >
                            <Image
                                size="contain"
                                src="Grape.png"                                  
                            />
                    </Box>                 
                </Box>

                {error !== "" && (
                    <Box pad="small"  margin={{top: 'medium'}}>                          
                        <Text color="red" margin={{horizontal: "medium"}} size="medium">{error}</Text>
                    </Box>)
                }
                <Box align="center" margin={{top: 'medium'}}  >                                    
                    <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line'}}><strong>Confirm year for selected treatment:</strong></span></Text>
                    <Box  width="25%" >
                        <TextInput
                            type="number"                        
                            value={props.year}
                            style={{ padding: "1px 0 1px 20px"}} 
                            onChange={(event) => 
                                props.onChangeYear(event.target.value)                            
                            }
                        />  
                    </Box>  
                </Box>
                <Box
                    as="footer"
                    gap="small"
                    direction="row"
                    align="center"
                    justify="end"
                    pad={{ top: 'medium', bottom: 'small' }}
                >
                    <Button
                        disabled={disable}
                        label={
                            <Text color="white">
                                <strong>Ok</strong>
                            </Text>
                        }
                        onClick={props.close}
                        primary                  
                    />  
                </Box>
            </Box>
        </Layer>
    )
}


///////////////////////////////////////////////////////////////////////////////////////////////
const arrow = (arrowDirection, handleChange) => {
    const changeDirection = () => {
        if(arrowDirection === 'next')
            handleChange('right');
        else 
            handleChange('left');
    }

    return(
        <Box  onClick={changeDirection} hoverIndicator round="small" background="light-2"  margin={{horizontal: "small"}}  width="30px"  height="30px" >
            <Card 
                style={{padding: "0px 5px 0 5px", weight: "bolder" }}  
            >
            {(arrowDirection === 'next') && (
                <Next color='neutral-3' size='26px' /> 
            )}
            {(arrowDirection === 'prev') && (
                <Previous color='neutral-3' size='26px' />
            )}
            </Card>
        </Box>
    );
}
////////////////////////////////////////////////////////////////////////////////////////////////

const ExistingEvaluation = (props) => {
   
    // used for navigate from another screen
    let { state } = useLocation();  
    let fromAnotherScreen = useRef(state.fromAnotherScreen);

    const { get, post } = useFetch(getDBURL());
    const navigate = useNavigate();

    const currentUser = useContext(UserContext);
    const { fieldList, currentSeason, finishSeason } = useDataContext();
    const { DBlogError } = useErrorLogger();
 
    const [success, setSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");  

    // console.log('In ExistingEvaluation currentUser.email >> ', currentUser.email);
    // console.log('In ExistingEvaluation fieldList >> ', fieldList);
    // console.log('In ExistingEvaluation  state >> ', state);

    // let seedlingId = props.seedlingId;
    let seedlingId = props.seedlingId || "";

    let seedlingYear = props.seedlingYear || "";
    const setSeedlingId = props.setSeedlingId;
    const setSeedlingYear = props.setSeedlingYear;
   
    let chosenOption = props.chosenOption;
    const setChosenOption = props.setChosenOption;

    const [dangerPopupOpen, setDangerPopupOpen] = useState(false); // Danger Popup Window
    const [dangerMessage, setDangerMessage] = useState('');
    const [dangerFuncOnConfirm, setDangerFuncOnConfirm] = useState('');

    const [addTreatmentsPopupOpen, setAddTreatmentsPopupOpen] = useState(false); // Danger Popup Window

    const [newCreatedStation, setNewCreatedStation] = useState(null);

    const [selectedCultivar, setSelectedCultivar] = useState(null); // State to store selected cultivar
    const [showCultivarDetails, setShowCultivarDetails]  = useState(false); // show popup with CultivarDetails 

    // console.log('loaded rootstock list >> ', res)

    const [selectedField, setSelectedField] = useState(
        {  Id: '00000000-0000-0000-0000-000000000000', 
            RowFrom: 0,
            RowTo: 0,
            FieldName: "",
            FieldType: 0,
            VinesOnRow: 0,
            Description: ""}); // selected station for render scions 


    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"        
    const [activeStationsList, setActiveStationsList] = useState([]); // list of station numbers for selection to see details
    useEffect(() => {
        if (fromAnotherScreen.current) {
            setActiveStationsList(state.activeStationsList); // Assuming state.activeStationsList is accessible
        }
      }, [fromAnotherScreen.current, state.activeStationsList]); 

    //   console.log('state.activeStationsList >> ', state.activeStationsList);
    //   console.log('activeStationsList >> ', activeStationsList);

    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getInitialSelectedStationState = () => {
        const defaultStation = {
            Id: '00000000-0000-0000-0000-000000000000',
            Name: '',
            DisplayName: '',
            RootstockId: '00000000-0000-0000-0000-000000000000',
            Rootstock: '',
            CultivarId: '00000000-0000-0000-0000-000000000000',
            FruitColor: '',
            Year: '',
            Mother: '',
            Father: '',
            SeedlingRow: '',
            SeedlingColumn: ''
        };
    
        if (fromAnotherScreen.current && state.selectedStation) {
            return state.selectedStation;
        }
        
        return defaultStation;
    };   
    const [selectedStation, setSelectedStation] = useState(getInitialSelectedStationState()); // selected station for render scions 



    const getinitialPhenologicalPhasesByStationState = () => {
        if (fromAnotherScreen.current) {
            return state.phenologicalPhasesByStation;
        }
        else{
            return { 
                StationId: '00000000-0000-0000-0000-000000000000', 
                Year: 0,
                BudBreakId: '00000000-0000-0000-0000-000000000000',
                FloweringId: '00000000-0000-0000-0000-000000000000',
                VeraisonId: '00000000-0000-0000-0000-000000000000',
                RipenessId: '00000000-0000-0000-0000-000000000000',                
                BudBreakDate: "",
                FloweringDate: "",
                VeraisonDate: "",
                RipenessDate: "",
            };         
        }
    };      

    const [phenologicalPhasesByStation, setPhenologicalPhasesByStation] = useState(getinitialPhenologicalPhasesByStationState()); // selected field
    const [phenologicalPhaseDateToChange, setPhenologicalPhaseDateToChange] = useState({Phase: 0, PhaseId: "00000000-0000-0000-0000-000000000000", DateValue: ""});  // selected date for change
 
    const [showChangePhenologicalPhase, setShowChangePhenologicalPhase]  = useState(false); // show popup to change date
    const [changePhenologicalPhaseMsg, setChangePhenologicalPhaseMsg] = useState('');   
    
    const [showStationCharacteristics, setShowStationCharacteristics]  = useState(false); // show popup with StationCharacteristics
    const [cultivarData, setCultivarData] = useState(null);    


    const [searchInput, setSearchInput] = useState(''); 

    const [scionsArr, setScionsArr] = useState([]); // List of scions growing in one station

    const [chosenVineInfo, setChosenVineInfo] = useState(null);
    
    const [mother, setMother] = useState({Id: '00000000-0000-0000-0000-000000000000', pId: ""});
    const [father, setFather] = useState({Id: '00000000-0000-0000-0000-000000000000', pId: ""});  
    const [rootstockList, setRootstockList]= useState([]);    // list of rootstocks for combo 
    // const [rootstock, setRootstock] = useState({Id: '00000000-0000-0000-0000-000000000000', Name: ""}); // the selected rootstock object to display in the combo box
    const [openParentsListWindow, setOpenParentsListWindow] = useState(false);
    const [treatmentsList, setTreatmentsList]= useState([]);   // list of treatments for combo 
    const [selectedTreatment, setSelectedTreatment] = useState({Id: '0', Name: ""});
    const [stationPostharvest, setStationPostharvest] = useState([]);  // postharvest on station (for button) 

    const [seedlingRow, setSeedlingRow] = useState(""); // a input field that allows to get seedlings by a specific year at specific row    
    useEffect(() => {
        if (fromAnotherScreen.current) {
            setSeedlingRow(state.seedlingRow);
        }
      }, [fromAnotherScreen.current, state.seedlingRow]);

    const [seedlingColumn, setSeedlingColumn] = useState(""); // a input field that allows to get seedlings by a specific year at specific column
    const [reRenderField, setReRenderField] = useState(false);   

    const [seedlingsArr, setSeedlingsArr] = useState(() => {
        // Initialize based on the initial conditions
        return fromAnotherScreen.current ? state.seedlingsArr : [];
    });
    // console.log('seedlingsArr >> ', seedlingsArr);

    const [parentsList, setParentsList] = useState([]); // parents list of seedlings on field
    const [mothersList, setMothersList] = useState([]); // mothers list of seedlings on field
    const [fathersList, setFathersList] = useState([]); // fathers list of seedlings on field
    const [newSeedlingLocations, setNewSeedlingLocations] = useState([]);  // array of objects {Row: 0, Col: 0} locations for new seedlings


    const [stationsListVisible, setStationsListVisible] = useState(false);
    const [numOfVisibleStations, setNumOfVisibleStations] = useState(3);   
    const [selectedScionList, setSelectedScionList] = useState([]); // list of selected scions (by checkbox) 
    const [selectedSeedlingList, setSelectedSeedlingList] = useState([]); // list of selected scions (by checkbox)
    const [openCreateStationsPopup, setOpenCreateStationsPopup] = useState(false); // not in use 

    const [openStationPopup, setOpenStationPopup] = useState(false); // open popup to create station
    // const [newStationCreatedSuccessfully, setNewStationCreatedSuccessfully] = useState(false);


    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getInitialShowTreatmentsState = () => {
        if (fromAnotherScreen.current) {
            return state.showTreatments;
        }
        else{
            return false;                     
        }
    };    
    const [showTreatments, setShowTreatments] = useState(getInitialShowTreatmentsState());

    const getInitialShowEvTreatmentsSummaryState = () => {
        if (fromAnotherScreen.current) {
            return state.showTreatmentsMultiYearSummary;
        }
        else{
            return false;                     
        }
    }; 
    const [showTreatmentsMultiYearSummary, setShowTreatmentsMultiYearSummary] = useState(getInitialShowEvTreatmentsSummaryState());
    const [bestTreatmentNum, setBestTreatmentNum] = useState('00000000-0000-0000-0000-000000000000'); 
    const [bestTreatmentBy, setBestTreatmentBy] = useState('');
    const [stationStartRow, setStationStartRow] = useState(0);
    


    // if we come from another screen by 'navigate', 
    // then we enter in the condition of "if",
    //  otherwise we enter in "else"
    const getInitialSeedlingsSectionVisibleState = () => {
        if (fromAnotherScreen.current) {
            return state.seedlingsSectionVisible;
        }
        else {
            return false;                     
        }
    };    
    const [seedlingsSectionVisible, setSeedlingsSectionVisible] = useState(getInitialSeedlingsSectionVisibleState());

    /** 
     * The (list?.) syntax ensures: list is checked for null or undefined before attempting to use find().
     * Null Coalescing Operator (??) syntax ensures: that if the find() method returns undefined (no element found), 
     * the function explicitly returns null instead.

     **   Return value:
     * Element Found: Returns the matching object.
     * Element Not Found: Returns null.
     * List is null or undefined: Returns null.
     */
    const getPlantInfoById = (list, id) => {
        return list?.find(element => element.Id === id) ?? null;
    };

    const getInitialShowSeedlingOnFieldState = () => {
        if (fromAnotherScreen.current) {
            return state.showSeedlingOnField;
        }
        else{
            return false;                     
        }
    };    
    const [showSeedlingOnField, setShowSeedlingOnField] = useState(getInitialShowSeedlingOnFieldState());
    const [showScionOnField, setShowScionOnField] = useState(false);
 
    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');

    // state for treatments or postharvest button
    const initSheetColorState = () => {
        return [
            {
                sheetID: null,
                sheetStatus: null,
                sheetYear: null,         
                sheetColor: "status-unknown",
                buttonLabel: "new treatment"
            },
        ];
    }
    // const [treatmentColor, setTreatmentColor] = useState(initSheetColorState());
     const [postharvestButton, setPostharvestButton] = useState(initSheetColorState());

    const [stationTreatments, setStationTreatments] = useState([]);  // list of only active treatments on station (for buttons) 
    const [allStationTreatments, setAllStationTreatments] = useState([]);  // list of all treatments on station
    const [openAddNewSeedlingWindow, setOpenAddNewSeedlingWindow] = useState(false);   
    const [yearValue, setYearValue] = useState(new Date().getFullYear()); // Year for display Date of Phenological Phases

    // Manage focus when opening modal windows
    usePopupFocus(showSeedlingOnField, "seed-on-field");
    usePopupFocus(showTreatments, "treat-list");
    usePopupFocus(showTreatmentsMultiYearSummary, "stat-summ");
    usePopupFocus(openAddNewSeedlingWindow, "add-seed");
    usePopupFocus(showWarning, "warning-msg");
    usePopupFocus(dangerPopupOpen, "danger-msg");
    usePopupFocus(showCultivarDetails, "cult-det");
    usePopupFocus(showStationCharacteristics,"stat-char");
    usePopupFocus(openStationPopup, "create-station");
    usePopupFocus(openParentsListWindow, "parents");
    usePopupFocus(addTreatmentsPopupOpen, "add-sc-to-treat");
    usePopupFocus(showChangePhenologicalPhase, "change-phen-phase");
    
    const handleChange = (direction) => {
        const currentYear = new Date().getFullYear();
        let newYearVal = yearValue;

        if(direction === 'right')
        {
            newYearVal += 1;
        }
        else  if(direction === 'left')
        {
            newYearVal -= 1;
        }
        
        if (newYearVal > currentYear) {
            setShowError(true);
            setNotificationMessage(' The entered year can not be more than the current year!!');                
            return;
        }

        if (newYearVal > 0 && newYearVal <= currentYear) {
            setYearValue(newYearVal);      
            loadPhenologicalPhase(selectedStation.Id, newYearVal);            
        }
    };

    const onChangeYear = (newYearVal) => {
        const currentYear = new Date().getFullYear();
        const isValid = isValidYearString(newYearVal, false);

        if (!isValid.res) {
            setShowError(true);
            setNotificationMessage(isValid.msg);                
            return;
        }

        if (newYearVal > currentYear) {
            setShowError(true);
            setNotificationMessage(' The entered year can not be more than the current year!!');                
            return;
        }

        if (isValid.res && newYearVal > 0 && newYearVal <= currentYear) {
            setYearValue(newYearVal);      
            loadPhenologicalPhase(selectedStation.Id, newYearVal);
        }
    }
    
    const onOpenNewStationPopup = () => {
        setOpenStationPopup(true);
    }

    const onCloseStationPopup = async() => { 
        setOpenStationPopup(false);         
    };

    const onOpenAddNewSeedlingWindow = () => {
        // console.log('newSeedlingLocations', newSeedlingLocations.length);
        if (newSeedlingLocations.length === 0)      
        {
            setWarningMessage('No locations for new seedlings selected!');
            setShowWarning(true);
            return;
        }
        else{
            setOpenAddNewSeedlingWindow(true);
        }
    }

    const onCloseAddNewSeedlingWindow = () => { 
        setOpenAddNewSeedlingWindow(false);
    };

    const onOpenParentsListWindow = () => {
        setOpenParentsListWindow(true);
    }

    const onCloseParentsListWindow = () => { 
        setOpenParentsListWindow(false);
    };

    const reRender = () => setReRenderField(!reRenderField);

    useEffect(() => {
        // console.log("In useEffect, fired on first mounting !! ");
        // I need a list of stations as parents when creating the new seedling
        const loadStations = async () => {       
            try {
                await loadParents();
                await loadActiveStations();
            }
            catch (error) {
                console.log("Error in useEffect, fired on first mounting >> ", error.message);
            }    
        };
        loadStations();

        // I need list of stations for creating station from seedling
        // loadActiveStations();
    }, []); 

    useEffect(() => {
        const loadNewCultivarData = async () => {       
            try {
                await loadActiveStations();
                await loadCultivarData(selectedStation.CultivarId);
            }
            catch (error) {
                console.log("Error in useEffect, fired on first mounting >> ", error.message);
            }    
        };
       
        if (selectedCultivar && !showCultivarDetails && selectedCultivar.IsCommercial === 1) {
            loadNewCultivarData();
            showStationButtons();

            const station = activeStationsList.filter((item) => {
                // console.log ('In searchItems item >> ', item);
                return (item.Id === selectedStation.Id && item.IsUprooted !== 1);
            });

            // console.log('In searchItems station >> ', station[0]);
            if (station !== undefined && station !== null && station.length > 0)
            {
                setSelectedStation({ 
                    Id: station[0].Id, 
                    Name: station[0].Name,
                    DisplayName: station[0].DisplayName,
                    RootstockId: station[0].RootstockId,
                    Rootstock: station[0].Rootstock,
                    CultivarId: station[0].CultivarId,
                    FruitColor: station[0].FruitColor,
                    Year: station[0].Year, 
                    Mother: station[0].Mother,
                    Father: station[0].Father,
                    SeedlingRow: station[0].SeedlingRow,
                    SeedlingColumn: station[0].SeedlingColumn});  
            }

        }
    }, [showCultivarDetails]); // Only trigger when IsCommercial changes   

    useEffect(() => {
        // console.log("useEffect:  fired on changing option /'Seedlings/' or /'Stations/'");

        if (fromAnotherScreen.current) {
            return;
        }

       if (chosenOption === "Stations")
       {      
            // console.log("in useEffect: selected option Stations"); 
            // clean screen
            setSeedlingId("");
            setSeedlingYear("");
            setSeedlingRow(""); 
            setSeedlingColumn("");
            setSeedlingsArr([]);
            setSelectedSeedlingList([]);
            setMother({Id: '00000000-0000-0000-0000-000000000000', pId: ""});
            setFather({Id: '00000000-0000-0000-0000-000000000000', pId: ""});
            setSeedlingsSectionVisible(false);
            setShowSeedlingOnField(false);
            setStationsListVisible(true);
        } else { // "Seedlings"
            // clean screen
            setStationsListVisible(false);  
            setSelectedScionList([]);
            setScionsArr([]);
            // setRootstock({ Id: '00000000-0000-0000-0000-000000000000', Name: '' });
            setSelectedTreatment({ Id: '00000000-0000-0000-0000-000000000000', Name: ''});
            setSelectedStation({ 
                Id: '00000000-0000-0000-0000-000000000000', 
                Name: '',
                DisplayName: '',
                RootstockId: '00000000-0000-0000-0000-000000000000', 
                Rootstock: '',
                CultivarId: '',
                FruitColor: '',
                Year: '',   
                Mother: '',
                Father: '',
                SeedlingRow: '',
                SeedlingColumn: ''});
        }                   
    }, [chosenOption])
 

    /*  I need a list of all the stations with at least one scion that hasn't been uprooted
        and cultivars not currently linked to any active station , 
        to choose parents for new seedlings,
        regardless of the field on which the station is located. **/
    async function loadParents() {
        try {
            const response = await get("/loadParents/dt=" + Date.now());

             // Check if the response is successful
             if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
             
            const res = response.result;

            // console.log('loaded Parents list >> ', res)
            if( res !== undefined && res.length > 0) {
                let stl = [];
                res[0].forEach(item => {
                    // console.log('item:  ', item);
                    const rs =  
                    {  
                        Id: item.Id,
                        Name: item.Name,
                        DisplayName: item.DisplayName,
                        Brand: item.cBrand,
                        Mother: item.Mother,
                        Father: item.Father,
                        CultivarId: item.CultivarId,   
                        RootstockId: item.RootstockId,
                        Rootstock: item.Rootstock,
                        StationRow: item.StationRow,                       
                        IsUprooted: item.IsUprooted,
                        ObjectType: item.ObjectType,
                    }
                    stl = stl.concat(rs);         
                });   
                // console.log('stations: -->  ', stl)
                setParentsList(stl);
            }
        }
        catch (error) {
            console.error(' 🔴 Error in loadParents >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in load Stations Data!!');
        }    
    }
    
    useEffect(() => {
        // console.log("useEffect:  fired on changing option seedlingId or year or parents at seedling");
        // console.log("seedlingYear >> " + seedlingYear);
        // console.log("seedlingId >> " + seedlingId);
        // console.log("seedlingRow >> " + seedlingRow);
        // console.log("seedlingColumn >> " + seedlingColumn);
        // console.log("mother >> ", mother);
        // console.log("father >> ", father);
        // console.log("selectedField >> ", selectedField);

        if (chosenOption === "Seedlings")
        { 
            setWarningMessage('');
            setShowWarning(false);            
            if (seedlingRow === '0') {
                return;
            }
                

            const field =  fieldList.filter(item => item.FieldType === 1 && Number(seedlingRow) >= item.RowFrom && Number(seedlingRow) <= item.RowTo)[0];
            // console.log("field >> ", field);  

            if (!field)      
            {
                setSeedlingsArr([]);
                setSelectedSeedlingList([]);
                setMothersList([]); 
                setFathersList([]); 
                if (seedlingRow !== '') {
                    // setWarningMessage(' The entered Row is not suitable for seedlings!');
                    // setShowWarning(true);
                }
            } else {
                const plantingYearIsValid = isValidYearString(seedlingYear, false, 'Planting Year');
                const year = plantingYearIsValid.res ? seedlingYear : "";

                (async function loadSeedlingsByYear() {
                    try {
                        // added parameter date.now to prevent hash

                        // const fieldNum = selectedField.Id != "00000000-0000-0000-0000-000000000000" ? selectedField.Id : '';
                        // const res = await get("/getSeedlingsByYear/id="+ seedlingId + "/year="+ seedlingYear + "/row=/col=/mother=/father=/dt=" + Date.now());
                        // const res = await get("/getSeedlingsByYear/id="+ seedlingId + "/year="+ seedlingYear + "/row="+ seedlingRow + "/col="+ seedlingColumn + "/mother="+ mother.Id + "/father="+ father.Id + "/dt=" + Date.now());
                        // const res = await get(`/getSeedlingsByYear/id=${seedlingId}/year=${seedlingYear}/field=${selectedField.Id === '00000000-0000-0000-0000-000000000000' ? '' : selectedField.Id}/row=${seedlingRow}/col=${seedlingColumn}/mother=${mother.Id === '00000000-0000-0000-0000-000000000000' ? '' : mother.Id}/father=${father.Id === '00000000-0000-0000-0000-000000000000' ? '' : father.Id}/dt=${Date.now()}`);
                        const response = await get(`/getSeedlingsByYear/id=${seedlingId}/year=${year}/field=${field.Id}/row=${seedlingRow}/col=${seedlingColumn}/mother=/father=/dt=${Date.now()}`);
            
                        // Check if the response is successful
                        if (!response.success) {
                            throw new Error(`HTTP error! ${response.message}`);
                        }
                
                        const res = response.result;
                        // console.log("seedlings by " + seedlingYear + ": ");
                        // console.log("  res.length in loadSeedlingsByYear:  >>>  ", res.length);
                        // console.log("  res in loadSeedlingsByYear:  >>>  ", res);
                        // console.log("  selectedSeedlingList in loadSeedlingsByYear:  >>>  ", selectedSeedlingList);
                        if( res !== undefined && res.length > 0)
                        {
                            let moList = [];
                            let faList = [];

                            res.forEach(item => {     
                                item.Checked = false;                            
                                // check if mother already in list (combo)
                                let found = moList.find(el => el.Id === item.MotherId);
                                if (found === undefined) {
                                    //  console.log('item >> ', item);
                                    const mo =  
                                    {  
                                        Id: item.MotherId,
                                        pId: item.MotherName,
                                    }
                                    moList = moList.concat(mo);   
                                }                                
                                // check if father already in list (combo)
                                found = faList.find(el => el.Id === item.FatherId); 
                                if (found === undefined) {
                                    //  console.log('item >> ', item);
                                    const fa =  
                                    {  
                                        Id: item.FatherId,
                                        pId: item.FatherName,
                                    }
                                    faList = faList.concat(fa); 
                                }                                       
                            });

                            if (selectedSeedlingList.length > 0) {
                                res.forEach(item => {
                                    // Check if the current item's Id exists in selectedSeedlingList
                                    const isSelected = selectedSeedlingList.some(selectedItem => selectedItem.Id === item.Id);
                                    // Update the Checked property based on existence in selectedSeedlingList
                                    item.Checked = isSelected;
                                });
                            }

                            setSeedlingsArr(res);
                            setMothersList(moList); 
                            setFathersList(faList);                             
                            if (fromAnotherScreen.current && state.showSeedlingOnField)
                            {
                                setChosenVineInfo(getPlantInfoById(res, state.chosenVineInfo.Id));
                                fromAnotherScreen.current = false; // Reset flag to avoid overwriting user choice                         
                            }
                        }         
                        else {
                            setSeedlingsArr([]);
                            setSelectedSeedlingList([]);
                            setNewSeedlingLocations([]);
                            setMothersList([]); 
                            setFathersList([]); 
                        }
                    }
                    catch (error) {
                        console.error(" 🔴 Error in useEffect, fired on changing option seedlingId or year or parents at seedling >> ", error.message);
                        setShowError(true);
                        setNotificationMessage(' An error occurred in uproot scions!!');
                    }                   
                })();

                setSelectedField(field);
                setSeedlingsSectionVisible(true);
            }
        }
    }, [seedlingYear, seedlingRow, seedlingColumn, reRenderField])

    // console.log("selectedField >> ", selectedField);
    useEffect(() => {
        // console.log('useEffect on change the selectedStation > selectedField >> ', selectedField);             
        // console.log('useEffect on change the selectedStation > selectedStation >> ', selectedStation);           
        // console.log('useEffect on change the selectedStation > activeStationsList >> ', activeStationsList);  
        // console.log('useEffect on change the selectedStation > chosenOption >> ', chosenOption);            

        // console.log("useEffect:  fired on selectedStation changing or in case one of the scions was changed outside  ");
        // console.log('In useEffect chosenOption is >> ', chosenOption);
        setSelectedTreatment({  
            Id: '0',
            Name:'',
        });

        setSelectedScionList([]);
        // console.log('useEffect on change the selectedStation !! ');
        const loadStationInfo = async () => {   
            // console.log("In loadStationInfo and selectedStation >> ", selectedStation);
            try {
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                await loadPhenologicalPhase(selectedStation.Id, currentYear)
                await loadCultivarData(selectedStation.CultivarId);
                await loadScions(selectedStation.Id);
                await loadTreatmentList(selectedStation); // load treatments for combo            
                await loadActiveTreatmentsByStation(selectedStation); // get active treatments for station
                await loadAllTreatmentsByStation(selectedStation); // get all treatments for station
            }
            catch (error) {
                console.log("Error in loadStationInfo >> ", error.message);
            }    
        };

        if (selectedStation && selectedStation.Id !== '00000000-0000-0000-0000-000000000000') {
            loadStationInfo();
        }

    }, [selectedStation, currentSeason])  
        
    // console.log('allStationTreatments >> ', allStationTreatments);
    
    // set color and label for the "postharvest" button displayed in the field on the station
    useEffect(() => {
        // console.log("useEffect:  fired on stationPostharvest changing ");
        // console.log(" stationPostharvest >> ", stationPostharvest);

        setPostharvestButton({  
            sheetId: stationPostharvest.PostHarvestId,
            sheetStatus: stationPostharvest.PostHarvestStatus,
            sheetYear: stationPostharvest.PostHarvestYear,
            sheetColor:
                stationPostharvest.PostHarvestStatus === 5 
                    ? "#bed3be"
                    : stationPostharvest.PostHarvestStatus === 4 
                        ? "#efef76"
                        : "status-unknown",
            buttonLabel:
                stationPostharvest.PostHarvestYear !== null ? stationPostharvest.PostHarvestName : "new postharvest"             
        });
    }, [stationPostharvest]); 

    useEffect(() => {
        if (selectedStation.Id !== '00000000-0000-0000-0000-000000000000') {
            // get all treatments for station
            loadAllTreatmentsByStation(selectedStation); 
        }
    }, [bestTreatmentNum])

    useEffect(() => {
        if (newCreatedStation && newCreatedStation.Id !== selectedStation.Id)
            changeSelectedStation(newCreatedStation); 
    }, [newCreatedStation])
   


    /**
     * Fetches and loads the list of active stations from the server.
     * Active stations are stations that are not uprooted.
     * This function updates both the list of stations (`stationsList`) and 
     * the available options for stations (`activeStationsList`).
     */
    async function loadActiveStations() {
        try {
            // Added a timestamp (Date.now) as a parameter to prevent response caching
            const response = await get(`/loadActiveStations/field_id=${''}/dt=${Date.now()}`);

            // Check if the response was successful
            if (!response.success) {
                throw new Error(`HTTP error: ${response.message}`);
            }

            const res = response.result;

            // Ensure the response contains data and update the stations lists
            if (res !== undefined && Array.isArray(res[0]) && res[0].length > 0) {
                const updatedStationsList = res[0];

                // Immediately update the activeStationsList state with the latest active stations
                setActiveStationsList(updatedStationsList);
                // console.log('loaded stations list ----  >  ', updatedStationsList); 

                // Map station data into the format required for active station options
                const newStationOps = updatedStationsList.map(station => ({
                    Id: station.Id,
                    Name: station.Name,
                }));

                // Update the activeStationsList state and adjust the number of visible stations
                // setActiveStationsList(() => {
                    setNumOfVisibleStations(prev => Math.min(Math.max(prev, 1), newStationOps.length));
                    setStationsListVisible(true); // Display the stations list
                //    return newStationOps; // Return the new list of active station options
                // });
            }
        } catch (error) {
            // Handle and log errors in the request
            console.error('🔴 Error in loadActiveStations >> ', error.message);
            setShowError(true); // Show an error state
            setNotificationMessage('An error occurred while loading active stations!'); // Display an error message
        }
    }


    
    const searchItems = (searchValue) => {
        // console.log('searchValue  >  ', searchValue); 
        // console.log('In searchItems activeStationsList >> ', activeStationsList);
        setSearchInput(searchValue);
        if (searchValue !== '') {
            const station = activeStationsList.filter((item) => {
                // console.log ('In searchItems item >> ', item);
                return (
                    (( (item.DisplayName && item.DisplayName.toLowerCase().includes(searchValue.toLowerCase()) )  ||
                        (item.Name && item.Name.toLowerCase().includes(searchValue.toLowerCase()))                     
                    ) && item.IsUprooted !== 1)
                );
            });

            // console.log('In searchItems station >> ', station[0]);
            if (station !== undefined && station !== null && station.length > 0)
            {
                setSelectedStation({ 
                    Id: station[0].Id, 
                    Name: station[0].Name,
                    DisplayName: station[0].DisplayName,
                    RootstockId: station[0].RootstockId,
                    Rootstock: station[0].Rootstock,
                    CultivarId: station[0].CultivarId,
                    FruitColor: station[0].FruitColor,
                    Year: station[0].Year, 
                    Mother: station[0].Mother,
                    Father: station[0].Father,
                    SeedlingRow: station[0].SeedlingRow,
                    SeedlingColumn: station[0].SeedlingColumn});  
            }
            else {
                setSelectedStation({ 
                    Id: '00000000-0000-0000-0000-000000000000', 
                    Name: '',
                    DisplayName: '',
                    RootstockId: '00000000-0000-0000-0000-000000000000',
                    Rootstock: '',
                    CultivarId: '',
                    FruitColor: '',
                    Year: '', 
                    Mother: '',
                    Father: '',
                    SeedlingRow: '',
                    SeedlingColumn: '' });
            }
        }
    }  

    // load scions for selected station
    async function loadScions(stationNum) {
        // console.log('In loadScions: stationNum >> ', stationNum);
        // setScionsArr([]);
        // setSelectedScionList([]);  

        // console.log("before loading scion list in f-n:  ", scionsArr);
        if (stationNum !== null && stationNum !== undefined && stationNum !== '00000000-0000-0000-0000-000000000000') { 
            // const fNum = fieldNum === undefined || fieldNum === '00000000-0000-0000-0000-000000000000' ? "" : fieldNum;
            try {
                // added parameter date.now to prevent hash
                // let res = await get("/loadScions/field_id=" + fieldNum + "/station_id=" + stationNum + "/dt=" + Date.now());
                // console.log('In if before loadScions: stationNum >> ', stationNum);

                const response = await get(`/loadScions/station_id=${stationNum}/field_id=${''}/dt=${Date.now()}`);
    
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
        
                const res = response.result;
                // console.log(" loaded scion list:  ", res);
                if (res !== undefined && res[0] !== undefined && res[0].length > 0)  {                    
                    res[0].forEach(item => {
                        if (typeof(item) === 'object') {
                            item.Checked = false; 

                            if (fromAnotherScreen.current && state.chosenVineInfo !== null && state.showScionOnField)
                            {
                                if (item.Id === state.chosenVineInfo.Id)
                                    setChosenVineInfo( item);
                            }
                        }     
                    })
                    setScionsArr(res[0]);  
                    setSelectedScionList([]);   
                }
            }
            catch (error) {
                console.error(' 🔴 Error in loadScions >> ', error.message);
                setShowError(true);
                setNotificationMessage(' An error occurred in load scions!!');                
            }
        }
    };
    // console.log('scionsArr >> ', scionsArr);

    // If the new inserted date does not coincide with the current year (other year),
    // the date will not be edited it will be inserted as new
    async function insertPhenologicalPhase(newDate) {
        try {
            let dateExist = false;
            let phenologicalPhasesId = null;
            if (newDate !== null) {
                const currentYear = new Date().getFullYear();
                const year = extractYearFromDateISOString(newDate);
                if (year > currentYear) {
                    setShowError(true);
                    setNotificationMessage(' The entered year can not be more than the current year!!');                
                    return;
                }
                    
                // Check if there is a phenological phase date for a given station in a given year in DB
                const response = await get("/loadPhenologicalPhases/station_id=" + selectedStation.Id + "/year=" + year + "/dt=" + Date.now());

                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
        
                const data = response.result;
                // console.log('data in loadPhenologicalPhase >> ', data);
                if (data !== undefined && data.length > 0 && data[0].length > 0) {
                    // console.log('👉  data >> ', data[0]);
                    const allDatesByYear = data[0][0];  // I must get only one row
                    // console.log('👉  allDatesByYear >> ', allDatesByYear);
                    phenologicalPhasesId = allDatesByYear[getPhenologicalPhaseOptions().find((option) => option.index === phenologicalPhaseDateToChange.Phase)?.fieldId];
                }
            }
            else {
                phenologicalPhasesId = phenologicalPhaseDateToChange.PhaseId;
            }

            dateExist = phenologicalPhasesId === null || phenologicalPhasesId === '00000000-0000-0000-0000-000000000000' ? false : true;

            let res = "";
            // console.log('phenologicalPhasesId  >>>   ', phenologicalPhasesId);
    
            if (!dateExist) {
                const insertValues = {
                    Id: generateSyncId(),
                    StationId: selectedStation.Id,
                    Phase: phenologicalPhaseDateToChange.Phase,
                    PhenologicalPhaseDate: correctTimeZone(newDate),
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    LastSyncDate: correctTimeZone(new Date()),
                };
    
                const response = await post(`/insertPhenologicalPhasesByStation/dt=${Date.now()}`, insertValues);
               
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
        
                res = response.result;

            } else {
    
                const updateValues = {
                    Id: phenologicalPhasesId,
                    PhenologicalPhaseDate: correctTimeZone(newDate),
                    ValueEditDate: correctTimeZone(new Date()),
                    ValueEditBy: currentUser.email,
                    LastSyncDate: correctTimeZone(new Date()),
                };
                const response = await post(`/updatePhenologicalPhasesByStation/dt=${Date.now()}`, updateValues);

                                
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
        
                res = response.result;
            }
            if (res !== "") {
                setPhenologicalPhaseDateToChange({ Phase: 0, PhaseId: '00000000-0000-0000-0000-000000000000', DateValue: "" });
                setShowChangePhenologicalPhase(false);
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                await loadPhenologicalPhase(selectedStation.Id, currentYear);
            }
        } catch (error) {
            console.error('🔴 Error in updating phenolic phase date >> ', error.message);
            setShowError(true);
            setNotificationMessage('Error occurred when updating phenolic phase date!');
        }
    };
    
    // load Phases
    async function loadPhenologicalPhase(stationNum, year) {
        // console.log('Parameters passed to loadPhenologicalPhase:', stationNum, year);
        try {
            // added parameter date.now to prevent hash
            const response = await get("/loadPhenologicalPhases/station_id=" + stationNum + "/year=" + year + "/dt=" + Date.now());
            // console.log('response in loadPhenologicalPhase >> ', response);

             // Check if the response is successful
             if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
             
            const res = response.result;
            if (res !== undefined && res.length > 0 && res[0].length > 0) {
                // console.log('👉  phases >> ', res[0]);
                const row = res[0][0];  // I must get only one row
                    setPhenologicalPhasesByStation({
                        StationId: row.StationId, 
                        Year: row.Year,
                        BudBreakId: row.BudBreakId,
                        FloweringId: row.FloweringId,
                        VeraisonId: row.VeraisonId,
                        RipenessId: row.RipenessId, 
                        BudBreakDate: row.BudBreakDate,
                        FloweringDate: row.FloweringDate,
                        VeraisonDate: row.VeraisonDate,
                        RipenessDate: row.RipenessPhase    
                });   
            }
        }
        catch (error) {
            console.error(' 🔴 Error in loadPhenologicalPhase >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in load PhenologicalPhase!!');            
        }
    }    


    const loadCultivarData = async (cultivarNum) => {       
        try {
            const response = await get("/loadCultivar/cultivarId=" + cultivarNum + "/dt=" + Date.now());
            
            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }

            const data = response.result;
            // console.log("loaded Cultivar data[0]:", data[0]);
            if( data !== undefined && data !== "" && data.length > 0) {
                // console.log("!!! loaded Cultivar data[0]:  ", data[0]);
                setCultivarData({
                    CultivarID: data[0].Id,  
                    CultivarName: data[0].CultivarName,     
                    Brand: data[0].Brand,
                    Type: data[0].Type, 
                    Harvest: data[0].Harvest, 
                    BudBreak: data[0].BudBreak, 
                    RainResistance: data[0].RainResistance, 
                    Chilling: data[0].Chilling,
                    IsCommercial: data[0].IsCommercial,
                    CreateDate: data[0].CreateDate,
                    CreatedBy: data[0].CreatedBy,
                }) 
            }
        } catch (error) {
            console.error(' 🔴 Error in f-n loadCultivarData >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in load Station Data!!');
        }  
    };

    // load treatments for combo
    async function loadTreatmentList(stationNum) {
        // console.log('In loadTreatmentList stationNum >> ', stationNum);
        try {
            // added parameter date.now to prevent hash
            const response = await get("/loadTreatmentsListByStation/station_id=" + stationNum.Id + "/dt=" + Date.now());
          
            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const res = response.result;
            // console.log('loadTreatmentList >> ', res);
            if (res !== undefined && res.length > 0) {
                let trl = [];
                res[0].forEach(item => {
                   //  console.log('item >> ', item);
                    const tr =  
                    {  
                        Id: Object.values(item)[0],
                        Name: Object.values(item)[1],
                    }
                    trl = trl.concat(tr);         
                });   
                // console.log('trl >> ', trl);
                setTreatmentsList(trl);        
            }
        }
        catch (error) {
            console.error(' 🔴 Error in loadTreatmentList error: ' + error.message);
            setShowError(true);
            setNotificationMessage('The loading of the treatments list was failed!!');
        }
    }

    // get active treatments (treatments in status 'in Progress') for station
    async function loadActiveTreatmentsByStation(station) {
        try {
            // console.log("station:  ", station);
            const response = await get("/loadTreatmentsByStation/station_id=" + station.Id + "/dt=" + Date.now())
            // console.log("response:  ", response);
            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const res = response.result;
            if (res !== undefined && res.length > 0) {
                // console.log("treatments list: ", res);
                setStationTreatments(res); 
            }        
        }
        catch(error) {
            console.error(' 🔴 Error in loadActiveTreatmentsByStation error: ', error.message);
            setShowError(true);
            setNotificationMessage('The loading of the active treatments was failed!!');
                            
            await DBlogError({
                error,
                parameters: JSON.stringify({ station: station}),
                userName: currentUser.email,
                moduleName: 'ExistingEvaluation',
                functionName: 'loadActiveTreatmentsByStation',
            });  
        }  
    };
  
    // get all treatments for station
    async function loadAllTreatmentsByStation() {
        if (selectedStation.Id !== '00000000-0000-0000-0000-000000000000') {
            try {
                // console.log("In loadAllTreatmentsByStation station:  ", selectedStation);
                const response = await get("/loadAllTreatmentsByStation/station_id=" + selectedStation.Id + "/dt=" + Date.now());
         
                // Check if the response is successful
                if (!response.success) {
                    throw new Error(`HTTP error! ${response.message}`);
                }
        
                const res = response.result;
                if (res !== undefined && res.length > 0) {
                    // console.log("All treatments list: ", res);
                    setAllStationTreatments(res); 
                    setBestTreatmentNum(res[0].BestTreatmentId);
                    setBestTreatmentBy(res[0].BestTreatmentBy);
                    setStationStartRow(res[0].StationStartRow);
                }   
                else {
                    setAllStationTreatments([]); 
                    setBestTreatmentNum('00000000-0000-0000-0000-000000000000');
                    setBestTreatmentBy('');
                    setStationStartRow(0);
                }   
            }
            catch(error) {
                console.error(' 🔴 Error in loadAllTreatmentsByStation error: ', error.message);
                setShowError(true);
                setNotificationMessage('The loading of the all treatments was failed!!');
                
                await DBlogError({
                    error,
                    parameters: JSON.stringify({ selectedStation: selectedStation}),
                    userName: currentUser.email,
                    moduleName: 'ExistingEvaluation',
                    functionName: 'loadAllTreatmentsByStation',
                });               
            }  
        }
    };
 
    async function finishScionTreatment(id) {
        try{
            const updateValues = {
                Id: id,
                FinishedAt: correctTimeZone(new Date()),
                FinishedBy: currentUser.email,
                LastSyncDate: correctTimeZone(new Date()),
            };
            const response = await post(`/finishScionTreatment/dt=${Date.now()}`, updateValues);
         
            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const res = response.result;
            // console.log("result in finishScionTreatment: ", res); 
            if (res !== undefined && res === 1) {
                loadAllTreatmentsByStation(selectedStation);  
                reRender();              
            }      
        }
        catch(error)
        {
            console.error(' 🔴 Error in finish ScionTreatment >> ', error.message)
            setShowError(true);
            setNotificationMessage('The finish Scion-treatment was failed!!');

            await DBlogError({
                error,
                parameters: null,
                userName: currentUser.email,
                moduleName: 'ExistingEvaluation',
                functionName: 'finishScionTreatment',
            });
        }  
    };

    const handleFinishSeason = async () => {
        // Check if the current season matches the current year and the month is December 
        if (currentSeason !== new Date().getFullYear() || new Date().getMonth() !== 11) {
            setShowError(true);
            setNotificationMessage('Cannot finish the season: Conditions are not met.');
            return;
        }
    
        try {
            // Call finishSeason from DataContext and await the result
            const result = await finishSeason();
    
            if (result === 1) {
                setSuccess(true);
                setNotificationMessage('Update successful: All rows have been updated. Season is finished.');
                reRender();
            } else {
                setShowError(true);
                setNotificationMessage('Update failed: Unable to finish the season.');
            }
        } catch (error) {
            console.error('Error in handleFinishSeason: ', error.message);
            setShowError(true);
            setNotificationMessage('An error occurred while finishing the season. Please try again.');
            
            await DBlogError({
                error,
                parameters: null,
                userName: currentUser.email,
                moduleName: 'ExistingEvaluation',
                functionName: 'handleFinishSeason',
            });
        }
    };

    // Function to fetch disqualification reason from database
    // const deleteDisqualReason = async (seedlingId) => {
    const deleteDisqualReason = async (SQLparams) => {
        // console.log('SQLparams:   ', SQLparams);
        try {
            const response = await post('/deleteDisqualificationReason/dt=' + Date.now(), SQLparams);
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }

            if (response?.success && response.result === 1) {
                // Row was successfully deleted
                const result = response.result;
                console.log("Row deleted:", result);
            } else if (response?.success && response.result === 0) {
                // No rows were deleted
                console.log("No rows were deleted.");
            } else if (response?.result === -1) {
                // An error occurred
                console.error("An error occurred while deleting the row.");
            } else {
                // Handle unexpected scenarios
                console.warn("Unexpected response:", response);
            }
            return response.result;
        } catch (error) {
            console.error(' 🔴 Error in deleteDisqualReason >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in delete Disqualification Reasons!!');

            await DBlogError({
                error,
                parameters: JSON.stringify({ SeedlingId: seedlingId, Year: new Date().getFullYear()}),
                userName: currentUser.email,
                moduleName: 'ExistingEvaluation',
                functionName: 'deleteDisqualReason',
            });
        }
    };

    // get postharvest for station
    async function loadPostharvestByStationId(stationNum) {
        try {
            // console.log("In loadPostharvestByStationId stationNum:  "+ stationNum);
            const res = await get("/loadPostharvestByStation/station_id=" + stationNum.Id + "/dt=" + Date.now());
            if (res !== undefined && res.length > 0) {
                // console.log("Postharvest list[0]: >> ", res[0]);
                setStationPostharvest(res[0]);
            }           
        }
        catch(error) {
            console.log(' 🔴 in loadPostharvestByStationId error: ' + error.message);
            setShowError(true);
            setNotificationMessage(error.message);
        }  
    };

    // load a list of scions that are in active treatment(status “In progress”) by station number
    // to avoid the situation when the scion, which is in active treatment, will be added to another treatment
    async function loadScionsInActiveTreatment(stationNum) {
        try {
            // added parameter date.now to prevent hash
            const response = await get("/loadScionsInTreatmentByStationId/station_id=" + stationNum.Id + "/dt=" + Date.now());
            // console.log('loadScionsInActiveTreatment >> ', res[0]);
         
            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }
    
            const res = response.result;
            if( res !== undefined && res.length > 0)
                return res[0];
            return [];
        }
        catch (error) {
            console.error(' 🔴 in loadScionsInActiveTreatment error: ', error.message);
            setShowError(true);
            setNotificationMessage(error.message);
        }
    }    

    // opens a popup window when the "uproot" button is clicked
    const openDangerPopupWindow = (msg, func) => {
        setDangerMessage(msg);
        setDangerFuncOnConfirm(() => func); // Store the callback function without executing it        
        setDangerPopupOpen(true);
    }


    // hides the "Danger" popup window 
    const onDangerPopupClose = () => {
        setDangerPopupOpen(false);
        setDangerMessage('');    
    };

    // fires when the "Yes" button is clicked in the "Danger" popup
    const onDangerConfirm = () => {
        // console.log(' << in function onDangerConfirm >> '); 
        if (typeof dangerFuncOnConfirm === 'function') {
            dangerFuncOnConfirm();
        } 
        onDangerPopupClose();
        setDangerFuncOnConfirm('');
    }; 

    // not in use
    async function uprootStation() {
        try {
            // console.log("selectedStation   >> ", selectedStation); 
            await post("/uprootStation/id=" + selectedStation.Id + "/uprooted=1/uprootedby="+ currentUser.email);
            // setSelectedStationStr('');
            setSelectedStation({ Id: '00000000-0000-0000-0000-000000000000', Name: '', Rootstock:''});
            //const fieldNum = selectedField === undefined || selectedField.Num === '00000000-0000-0000-0000-000000000000' ? null : selectedField.Id;        
            await loadActiveStations();
            await props.loadVarieties();
        }
        catch (error) {
            console.error(' 🔴 Error in uprootStation >> ', error.message);
            setShowError(true);
            setNotificationMessage(error.message);
        }
    };

    async function uprootScions() {
        try {
            // Prepare scions data for uprooting
            const scions = selectedScionList.map((item) => ({
                Id: item.Id,
                UprootedAt: correctTimeZone(new Date()),
                UprootedBy: currentUser.email,
                LastSyncDate: correctTimeZone(new Date())
            }));

            // Send scions data to backend
            const response = await post(`/uprootScions/dt=${Date.now()}`, scions);

            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }

            const uprootedCount = response.result;

            // If uprooting was successful and some scions were uprooted
            if (uprootedCount && uprootedCount > 0) {
                // Synchronize scionsArr with updated UprootedAt values
                const updatedScionsArr = scionsArr.map(scion => {
                    const updatedScion = scions.find(s => s.Id === scion.Id);
                    return updatedScion ? { ...scion, UprootedAt: updatedScion.UprootedAt } : scion;
                });

                // Update the state with the updated scionsArr
                setScionsArr(updatedScionsArr);

                // Use updatedScionsArr to check if all scions in the station are uprooted
                const stationUprooted = updatedScionsArr.every(scion => scion.UprootedAt !== null);

                if (stationUprooted) {
                    // Handle selecting the previous station
                    const prevStation = getPreviousStation();

                    // Set the previous station as selected
                    setSelectedStation(prevStation);
                    setSelectedScionList([]); // Clear the selected scion list

                    // Reload the active stations
                    await loadActiveStations();

                    // load parents edited list
                    await loadParents();
                } else {
                    // Reload the scions for the selected station if not all were uprooted
                    await loadScions(selectedStation.Id);
                    setSelectedScionList([]); // Clear the selected scion list
                }
            }
        } catch (error) {
            console.error('🔴 Error in uprootScions >> ', error.message);
            setShowError(true);
            setNotificationMessage('An error occurred during the scion uprooting process!');
        }
    }

    /**
     * Helper function to retrieve the previous station.
     * Returns the station before the selected one or the first available station.
     */
    function getPreviousStation() {
        // console.log("activeStationsList   >> ", activeStationsList);
        if (activeStationsList && activeStationsList.length > 0) {
            const currentIndex = activeStationsList.findIndex(
                element => element.Id === selectedStation.Id
            );
            // Return the previous station if available, otherwise return the first station
            return currentIndex > 0 ? activeStationsList[currentIndex - 1] : activeStationsList.length > 1 ? activeStationsList[1] : activeStationsList[0];
        }
        // If no active stations are available, return an empty placeholder object
        return {
            Id: '00000000-0000-0000-0000-000000000000',
            Name: '',
            DisplayName: '',
            RootstockId: '00000000-0000-0000-0000-000000000000',
            Rootstock: '',
            CultivarId: '',
            FruitColor: '',
            Year: '', 
            Mother: '',
            Father: '',
            SeedlingRow: '',
            SeedlingColumn: ''
        };
    }

    async function uprootSeedlings() {
        try {        
            // console.log(" 🖖 In uprootSeedlings selectedSeedlingList   >> ", selectedSeedlingList); 
            // Initialize the seedling object inside the loop
            const seedlings = selectedSeedlingList.map((item) => {
                // Create a new seedling object for each iteration
                // console.log('item >> ', item);
                const seedling = {
                    Id: item.Id,
                    UprootedAt: correctTimeZone(new Date()),
                    UprootedBy: currentUser.email,
                    LastSyncDate: correctTimeZone(new Date()),
                };
                return seedling;
            });

            // console.log(" 🖖 In uprootSeedlings seedlings   >> ", seedlings); 
            const response = await post('/uprootSeedlings/dt=' + Date.now(), seedlings);

            // Check if the response is successful
            if (!response.success) {
                console.log("In uprootSeedlings response   >> ", response.message); 
                throw new Error(`HTTP error! ${response.message}`);
            }

            const uprooted = response.result
            // console.log("In uprootSeedlings uprooted   >> ", uprooted); 

            if (uprooted && uprooted > 0) {
                setSelectedSeedlingList([]);
                reRender();
            }

        } catch (error) {
            console.error(' 🔴 Error in uprootSeedlings >> ', error.message);
            setShowError(true);
            setNotificationMessage(' An error occurred in uproot seedling!!');
        }
    };


    // // add/remove scionId's to/from the list of checked (checkbox) for adding treatment
    const addScionToSelected = (scion, checked) => {
        let updatedScionList = [...selectedScionList];
    
        // Check if the scion is already in the selected list
        const index = selectedScionList.findIndex(el => el.Id === scion.Id);
    
        if (checked && index === -1) {
            // If the scion is not found in the selected list and it's checked, add it to the list
            updatedScionList.push({ ...scion, Checked: true });
        } else if (!checked && index !== -1) {
            // If the scion is found in the selected list and it's unchecked, remove it from the list
            updatedScionList.splice(index, 1);
        }
    
        // Update the selected scion list
        setSelectedScionList(updatedScionList);
    
        // Update the scions array with the new checked status
        setScionsArr(prevState => {
            return prevState.map(el =>
                el.Id === scion.Id ? { ...el, Checked: checked } : el
            );
        });
    };
    

    // add/remove seedlingId's to/from the list of checked (checkbox) for uprooting
    const addSeedlingToSelected = (seedling, checked) => {
        let updatedSeedlingList = [...selectedSeedlingList];
    
        // Check if the seedling is already in the selected list
        const index = selectedSeedlingList.findIndex(el => el.Id === seedling.Id);
    
        if (checked && index === -1) {
            // If the seedling is not found in the selected list and it's checked, add it to the list
            updatedSeedlingList.push({ ...seedling, Checked: true });
        } else if (!checked && index !== -1) {
            // If the seedling is found in the selected list and it's unchecked, remove it from the list
            updatedSeedlingList.splice(index, 1);
        }
    
        // Update the selected seedling list
        setSelectedSeedlingList(updatedSeedlingList);
    
        // Update the seedling array with the new checked status
        setSeedlingsArr(prevState => {
            return prevState.map(el =>
                el.Id === seedling.Id ? { ...el, Checked: checked } : el
            );
        });
    };

    const openTreatment = async (treatment) => {
        if (treatment.treatmentID === null)
        {  
            if (selectedScionList.length === 0)      
            {
                setWarningMessage('No selected scions');
                setShowWarning(true);
                return;
            }
            else{
                // check if the scion is in another active treatment group
                const scions = await loadScionsInActiveTreatment(selectedStation);
                if (scions.length > 0) {
                    const found = scions.some(r => selectedScionList.includes(r.ScionId));
                    // console.log(' 🖖 found >> ', found);
                    if (found)
                    {
                        setWarningMessage('One or more of selected scions are in active treatment');
                        setShowWarning(true);
                        return;
                    }
                }
            }
        }
        OpenTreatmentSheet(treatment);
    }        


    const addTreatment = async (treatment) => {
        if (selectedScionList.length === 0)      
        {
            setWarningMessage('No selected scions');
            setShowWarning(true);
            return;
        }
        else{
            // check if the scion is in another active treatment group
            const scions = await loadScionsInActiveTreatment(selectedStation);
            if (scions.length > 0) {
                const found = scions.some(scion => selectedScionList.some(selectedScion => selectedScion.Id === scion.ScionId));
                // console.log('found >> ', found);
                if (found)
                {
                    setWarningMessage('One or more of selected scions are in active treatment');
                    setShowWarning(true);
                    return;
                }
            }
        }
        setAddTreatmentsPopupOpen(true);
    }   

    
    const isUprootScions = async () => {
        if (selectedScionList.length === 0)      
        {
            setWarningMessage('No selected scions');
            setShowWarning(true);
            return;
        }
        else{
            openDangerPopupWindow("Selected scions will be uprooted! Are you sure you want to continue?", uprootScions);
        }
    }   


    const isUprootSeedlings = async () => {
        if (selectedSeedlingList.length === 0)      
        {
            setWarningMessage('No selected seedlings');
            setShowWarning(true);
            return;
        }
        else{
            openDangerPopupWindow("Selected seedlings will be uprooted! Are you sure you want to continue?", uprootSeedlings);
        }
    }  

    const closeWarning = () => {
        setShowWarning(false);
        setWarningMessage('');
    }

    const onCloseCreateStationsPopup = () => { 
        setOpenCreateStationsPopup(false);
    };

    const OpenTreatmentSheet = (treatment) => {
        // console.log('ExistingEvaluation: in OpenSheet f-n  >> ');
        // console.log('plant >> ', plant);
        // console.log('treatment >> ', treatment);
        // console.log('activeStationsList >> ', activeStationsList);
        // console.log('showTreatmentsMultiYearSummary >> ', showTreatmentsMultiYearSummary);
        if (treatment.treatmentID === null)
        { 
            navigate("/treatment", {  
                state: {
                    station: selectedStation,
                    phenologicalPhasesDates: phenologicalPhasesByStation,
                    cultivarData: cultivarData,
                    rootstockList: rootstockList,
                    activeStationsList: activeStationsList,
                    scionsList: selectedScionList,
                    editMode: false,
                    disable: false,                    
                    sheetName: "TREATMENT",
                    showTreatments: showTreatments,
                    treatmentID: treatment.treatmentID,
                    showTreatmentsMultiYearSummary: showTreatmentsMultiYearSummary,
                },                
            
            });}
        else {
            navigate("/treatment", {
                state: {
                    station: selectedStation, 
                    phenologicalPhasesDates: phenologicalPhasesByStation, 
                    cultivarData: cultivarData,
                    rootstockList: rootstockList, 
                    activeStationsList: activeStationsList,
                    scionsList: selectedScionList,                                     
                    editMode: true,
                    disable: treatment.treatmentStatus === 5,
                    sheetName: "TREATMENT",
                    showTreatments: showTreatments,                    
                    treatmentID: treatment.treatmentID,
                    showTreatmentsMultiYearSummary: showTreatmentsMultiYearSummary,
                },                  
            });
        }
    }
    
    const openPostharvestSheet = () => {
       if (postharvestButton.sheetId === null) {
            navigate("/postharvest", {
            state: {
                station: selectedStation,  
                activeStationsList: activeStationsList,
                scionsList: selectedScionList,                                     
                editMode: false,
                disable: false,
                PostharvestID: postharvestButton.sheetId,
            },
            });
        } else {
            navigate("/postharvest", {
            state: {
                station: selectedStation,  
                rootstockList: rootstockList, 
                activeStationsList: activeStationsList,
                scionsList: selectedScionList,                                     
                editMode: true,
                disable: postharvestButton.sheetStatus !== 4,
                PostharvestID: postharvestButton.sheetId,
            },
            });
        }
    }

    // const handleKeyDown = (event) => {
    //     if (event.key === 'Enter') {
    //         // alert(event.target.value);
    //         // loadSeedlingsByYear(1, 2, 2021);
    //         setSeedlingYear(event.target.value);            
    //     }
    // }

    const onCreateNewStation = async(station) => {
        // if (station.Id !== '00000000-0000-0000-0000-000000000000') {
            // console.log('In onCreateNewStation stationId  >> ', station);
            await loadParents();
            await loadActiveStations();
            setSelectedScionList([]);
            setChosenOption("Stations");
            setNewCreatedStation(station);
        // }
    };  

    const changeSelectedStation = (station) => {
        // console.log('station  >> ', station);
        // console.log('SelectedStation >> ', selectedStation);
        if (station) {
            setSelectedStation(prevSelectedStation => {
                const found = activeStationsList.find(el => station.cId !== undefined ? el.Id === station.cId :  el.Id === station.Id);
                if (found !== undefined) {
                    return {
                        Id: found.Id, 
                        Name: found.Name,
                        DisplayName: found.DisplayName,
                        RootstockId: found.RootstockId,
                        Rootstock: found.Rootstock,
                        CultivarId: found.CultivarId,
                        FruitColor: found.FruitColor,
                        Year: found.Year,
                        Mother: found.Mother,
                        Father: found.Father,
                        SeedlingRow: found.SeedlingRow,
                        SeedlingColumn: found.SeedlingColumn 
                    };
                } else {
                    return {
                        Id: '00000000-0000-0000-0000-000000000000', 
                        Name: "",
                        DisplayName: '',
                        RootstockId: '00000000-0000-0000-0000-000000000000', 
                        Rootstock: "",
                        CultivarId: '',
                        FruitColor: '',
                        Year: '',
                        Mother: '',
                        Father: '',
                        SeedlingRow: '',
                        SeedlingColumn: ''
                    };
                }
            });
        }
    };

    const onCreateNewCultivar = () => {
        // console.log('Existing Evaluation cultivarData  >>>  ', cultivarData);
        // console.log('Existing Evaluation selectedStation  >>>  ', selectedStation);
        const cultivar = {
            // Id: generateSyncId(),
            CultivarID: cultivarData.CultivarID,
            CultivarName: cultivarData.CultivarName,
            Brand: cultivarData.Brand,
            Mother: selectedStation.Mother,
            Father: selectedStation.Father,
            // RootstockId: selectedStation.RootstockId,
            Type: cultivarData.Type,
            // FruitColor: cultivarData.Type,
            Harvest: cultivarData.Harvest,
            BudBreak: cultivarData.BudBreak,
            RainResistance: cultivarData.RainResistance,
            Chilling: cultivarData.Chilling,
            CreateDate: cultivarData.CreateDate,
            CreatedBy: cultivarData.CreatedBy,
            IsCommercial: 1,
            CommercialFromDate: null,
            SetAsCommercialBy: null,
            AddDate: null,
            AddedBy: null,
            Country: 'Israel',
            Company:'Volcani Center',
            Notes: '',
            LastSyncDate: null
        };
            
        // Set the selected cultivar in state
        setSelectedCultivar(cultivar);
    
        // Show the cultivar details
        setShowCultivarDetails(true);
    };

    const onScionClick = (scioId) => {
        const updatedScionsArr = scionsArr.map(scion => ({
            ...scion,
            Checked: scion.Id === scioId ? !scion.Checked : scion.Checked
        }));
        setScionsArr(updatedScionsArr);
        setSelectedScionList(updatedScionsArr.filter(scion => scion.Checked)); // Update selected scion list with scions where Checked is true
    }
       
    // getSheetNames(filePath)
    //   .then(sheetNames => {
    //     console.log('Sheet names:', sheetNames);
    //     // Now you can choose which sheet to read or iterate through each sheet
    //     // Example: read data from the first sheet
    //     // readExcelAndInsertIntoSQL(filePath, sheetNames[0]);
    //   })
    //   .catch(error => {
    //     console.error('Error:', error.message);
    //   });

     
    // const [file, setFile] = useState(null);

    // const handleFileChange = (event) => {
    //     setFile(event.target.files[0]);
    // };


    const [iconClicked, setIconClicked] = useState(false);
    const [iconDisabled, setIconDisabled] = useState(false);
    
    const handleSubmit = async () => {
        try {
            setIconDisabled(true); // Disable the icon
            setIconClicked(true); // Reset clicked state
            const timestamp = Date.now();
            const response = await post(`/upload/timestamp=${timestamp}`);

            let alertMsgs = [];
            if (response.success) {
                response.resultMsgs.forEach(message => {
                    alertMsgs.push(message);
                });
                alert(alertMsgs.join('\n'));
            } else {
                throw new Error('Failed to insert data.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred.');
        } finally {
            setIconDisabled(false); // Enable the icon
            setIconClicked(false); // Reset clicked state
        }
    };
    
    const menuItems = [
        {
          label: "Station Characteristics",
          action: () => setShowStationCharacteristics(true),
          color: "status-unknown",
        },
        {
          label: "Uproot Scions",
          action: () => isUprootScions(),
          color: "#A2423D",
          style: { color: "#ffffff" },
        },
        //...(cultivarData.IsCommercial !== 1
         // ?
         //  [
              {
                label: "Set as Cultivar",
                action: onCreateNewCultivar,
                color: "#89b9b9",
              },
       //     ]
       //   : []),
        ,{
          label: "Invert Selection",
          action: () => {
            const updatedScionsArr = scionsArr.map((scion) => ({
              ...scion,
              Checked: !scion.Checked,
            }));
            setScionsArr(updatedScionsArr);
            setSelectedScionList(updatedScionsArr.filter((scion) => scion.Checked));
          },
          color: "neutral-3",
          style: { color: "#ffffff" },
        },
      ];

 
// console.log('stationTreatments.length >> ', stationTreatments.length);
// console.log('allStationTreatments.length >> ', allStationTreatments.length);
// console.log('newSeedlingLocations >> ', newSeedlingLocations);
// console.log('selectedSeedlingList >> ', selectedSeedlingList);

    const buttons = [
        {
          label: "station characteristics",
          letter: "i", // Display letter instead of an icon
          onClick: () => setShowStationCharacteristics(true),
          id: "stationCharacteristics",
          color: "#919191",
        },
        {
          label: "uproot scions",
          icon: <Trash color="white" size="16px" />,
          onClick: isUprootScions,
          id: "uprootScions",
          color: "#A2423D",
        },
        {
          label: "set as cultivar",
          icon: <Certificate color="white" size="16px" />,
          onClick: onCreateNewCultivar,
          id: "setAsCultivar",
          color: "#89b9b9",
          condition: cultivarData?.IsCommercial !== 1, // Display condition
        },
        {
          label: "invert selection",
          icon: <FormCheckmark color="white" size="30px" />,
          onClick: () => {
            const updatedScionsArr = scionsArr.map((scion) => ({
              ...scion,
              Checked: !scion.Checked, // Toggle the Checked property
            }));
            setScionsArr(updatedScionsArr);
            setSelectedScionList(
              updatedScionsArr.filter((scion) => scion.Checked)
            ); // Update selected scion list
          },
          id: "invertSelection",
          color: "#00739D",
        },
        {
            label: "Treatments",
            letter: "T",
            id: "treatments",
            color: "#89b9b9",
            subMenu: [
                {
                    label: "Evaluations Summary",
                    letter: "S",
                    onClick: () => setShowTreatmentsMultiYearSummary(true),
                    id: "evSummary",
                    color: "#919191",
                },
                {
                    label: "New Treatment",
                    letter: "N",
                    onClick: () => addTreatment(),
                    id: "newTreatment",
                    color: "#89b9b9",
                    //condition: stationTreatments.length > 0, // Display condition
                },
                {
                    label: "All Treatments",
                    letter: "A",
                    onClick: () => setShowTreatments(true),
                    id: "allTreatments",
                    color: "#00739D",
                    // condition: allStationTreatments.length > 0 , // Display condition
                },
            ],
          },
      ];




    // f-n gets number of station of scion , returns id of seedling from it was created the station
    async function getSeedlingForStation(stationID) { 
        const seedling = await get("/getSeedlingByStationId/station_id=" + stationID)
        setSeedlingId(seedling.toString());
    };

    // console.log('seedlingsArr >> ', seedlingsArr);
    // console.log('seedlingsSectionVisible >> ', seedlingsSectionVisible);
    // console.log('selectedField  >> ', selectedField);
    // console.log('selectedStation  >> ', selectedStation);

    const hasName = selectedStation != undefined && selectedStation.Name && selectedStation.Name.trim() !== "";
 
    const StationNameStyle = {
      whiteSpace: "nowrap",
      color: "#4B7B4B",
      // background: hasName ? "#EDEDED" : "transparent", // Set background color conditionally
      background: "transparent", 
      fontWeight: "bold",
      fontStyle: "italic", // Add this line for italic text
      fontSize: "26px", 
      margin: "7px 5px",
    };

    const textStyle = {
        whiteSpace: "nowrap",
        align: "start",
        background: "transparent", 
        fontWeight: "bold",
        fontStyle: "italic", // Add this line for italic text
        fontSize: "18px", 
 //       margin: "2px"
      };   
      
    const  StationLabelStyle = {
        whiteSpace: "nowrap",
        background: "transparent", 
        fontWeight: "bold",
        fontSize: "14px",
        margin: "2px"
    };

    const showStationButtons = () => {
        return (
            <Box pad={{ vertical: "small" }} direction="row-responsive" wrap justify="center">
                {/* Row 1 */}
                <Box direction="row" wrap justify="center">
                    <Box pad="xxsmall" width="160px">
                        <Button
                            color="status-unknown"
                            primary
                            label="station characteristics"
                            onClick={() => setShowStationCharacteristics(true)}
                        />
                    </Box>
                    <Box pad="xxsmall" width="160px">
                        <Button
                            style={{ color: "#ffffff" }}
                            color="#A2423D"
                            primary
                            label="uproot scions"
                            onClick={() => isUprootScions()}
                        />
                    </Box>
                </Box>
                {/* Row 2 */}
                {/* {console.log('cultivarData --->>  ', cultivarData)} */}
                <Box direction="row" wrap justify="center">
                    {cultivarData.IsCommercial !== 1 &&
                    <Box pad="xxsmall" width="160px">
                        <Button
                            color="#89b9b9"
                            primary
                            label="set as cultivar"
                            onClick={onCreateNewCultivar}
                        />
                    </Box>
                }
                    <Box pad="xxsmall" width="160px">
                        <Button
                            style={{ color: "#ffffff" }}
                            primary
                            label="invert selection"
                            onClick={() => {
                                const updatedScionsArr = scionsArr.map((scion) => ({
                                ...scion,
                                Checked: !scion.Checked, // Toggle the Checked property
                                }));
                                setScionsArr(updatedScionsArr);
                                setSelectedScionList(updatedScionsArr.filter((scion) => scion.Checked)); // Update selected scion list with scions where Checked is true
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        );
      };
      
      
    const labelStyle = {
        fontSize: "medium",
        fontWeight: "bold",
        margin: "small",
        whiteSpace: "nowrap"
    };

    // console.log('seedlingsSectionVisible  >>  ', seedlingsSectionVisible);
    // console.log('selectedStation  >>  ', selectedStation);
    // console.log('  ❌  showWarning >>>> ', showWarning);
    
    
    return (
        <Form > 
        {showError && (
            <Notification
            status="critical"
            message={`${notificationMessage}.`}
            onClose={() => setShowError(false)}
          />
        )} 

        {success && (
            <Notification
                status="normal"
                message={`${notificationMessage}`}
                onClose={() => setSuccess(false)}
            />
        )}        
        <ResponsiveContext.Consumer>
        {screenSize => (
        <Box direction="column" responsive={true} width="80vw" padding="xxsmall"> 

            <Box direction="row-responsive" flex wrap justify="around">
                <Box direction="row-responsive" width="600px">
                    <Box pad="small"  justify="center" align="center" width="400px">
                        <RadioButtonGroup
                            direction="row"
                            name="radio"
                            options={props.options}
                            style={{fontWeight: "bold", fontSize: "18px",}}
                            value={chosenOption}
                            onChange={(event) => {
                                setChosenOption(event.target.value);
                            }}
                        />
                    </Box>

                    <Box justify="center" align="center" > 
                        <Box width= "200px" wrap={true} >
                            <Button
                                label="finish season"
                                primary 
                                margin={{ horizontal: "small", vertical: "xxsmall" }}
                                color="#A2423D" 
                                style={{color: "#ffffff"}}
                                onClick={()=> openDangerPopupWindow("This action will permanently alter the database, and the data will be irretrievable. Are you sure you want to proceed?", handleFinishSeason)}
                                disabled={!(currentSeason === new Date().getFullYear() && new Date().getMonth() === 11)} // Disable the button if it's not December of current year
                            />
                        </Box> 
                    </Box>

                    <Box direction="row-responsive" align="center" >
                        {/* <TextInput type="file" accept=".xlsx" onChange={handleFileChange} /> */}
                        {/* <Box  direction="row-responsive"  align="center" width="40px"  min-width="40px" >                                                   
                                <Box pad="xsmall" width= "40px" key={Math.random(Date.now())} border>
                                <DocumentExcel
                                    color={iconClicked ? 'red' : 'green'}
                                    disabled={iconDisabled}
                                    onClick={handleSubmit}
                                />
                            </Box>
                        </Box> */}
                    </Box>
                </Box>

                <Box direction="row-responsive"  >
                    {chosenOption === "Stations" && (
                    <Box direction="row-responsive" align="center" wrap width="600px">
                        <Box direction="row" wrap align="center" width="400px" >
                            <Box>
                                <Text style={labelStyle}>Find a station:&nbsp;&nbsp;</Text> 
                            </Box>
                            <Box direction="row" border= {{color: "brand"}} >
                                <TextInput
                                    hoverIndicator={true}
                                    focusIndicator={false}
                                    placeholder="Search..." 
                                    value={searchInput}
                                    style={{ padding: "5px 0 5px 10px"}}
                                    plain
                                    onChange={(e) => searchItems(e.target.value)}                                                         
                                    /> 
                                    {searchInput === ""
                                    ? <Search style={{ margin:"5px"}}  color={"brand"} /> 
                                    : <Box as="span" hoverIndicator><FormClose style={{ margin:"5px"}} color= "brand" onClick={()=>{setSearchInput("")}}/></Box>
                                    }
                            </Box>
                        </Box>

                        <Box direction="row" align="center" wrap >
                            <Box width= "200px">
                                <Button
                                    label="create station"
                                    primary
                                    margin={{ horizontal: "small", vertical: "xxsmall" }}
                                    style={{color: "#ffffff"}}
                                    onClick={onOpenNewStationPopup}
                                />
                            </Box>
                        </Box>
                    </Box> 
                    )}

                    {chosenOption === "Seedlings" && (            
                    <Box pad="xxsmall" direction={screenSize < "small" ? "row-responsive" : "row"} align="center" wrap > 
                                <Box direction="row" width="140px"  align="center">
                                    <Text style={labelStyle} >Row:&nbsp;&nbsp;</Text>                            
                                    <TextInput type="text"
                                        value={seedlingRow}  
                                        style={{ padding: "5px 0 5px 10px", width: "60px", height: "30px"}} 
                                        
                                        onChange={(event) => {
                                            setSeedlingRow(event.target.value);
                                        }}
                                    />

                                </Box>
                                <Box  direction="row" width="140px"   align="center" >
                                    <Text style={labelStyle}>Vine:&nbsp;&nbsp;</Text>

                                    <TextInput type="text"
                                        value={seedlingColumn} 
                                        style={{ padding: "5px 0 5px 10px", width: "60px", height: "30px"}} 
                                        onChange={(event) => {
                                            setSeedlingColumn(event.target.value);
                                        }}
                                    />

                                </Box>
                            {/* </Box> */}
                            <Box  direction="row" width="220px"  align="center" >
                                <Text style={labelStyle}>Planting Year:&nbsp;&nbsp;</Text>               
                                <TextInput type="text"
                                    value={seedlingYear}
                                    size="medium"
                                    style={{ padding: "5px 0 5px 10px", width: "60px", height: "30px"}} 
                                    onChange={(event) => {
                                        setSeedlingYear(event.target.value);
                                        setSeedlingId('');
                                    }}
                                    // onKeyDown={handleKeyDown} 
                                />
                            </Box>

                    </Box>

                    )}
                </Box>
            </Box>

            {openParentsListWindow && 
            <ParentsListWindow 
                parentsList={activeStationsList} 
                searchValue={selectedStation.Id !== '00000000-0000-0000-0000-000000000000' ? searchInput : ''}
                onClose={onCloseParentsListWindow}
                changeParent={changeSelectedStation} 
                prevParent={selectedStation}>
            </ParentsListWindow>}

            {dangerPopupOpen && (
                <DangerPopupWindow
                    msg={dangerMessage}
                    onClose={onDangerPopupClose}
                    onConfirm={onDangerConfirm}
                />
            )}

            {showWarning && (
                <WarningPopupWindow msg={warningMessage} close={closeWarning}/>
            )}

        {/* {console.log('screenSize  >>  ', screenSize)} */}
        {chosenOption === "Seedlings" && (
            <Box align="center">
                {seedlingsSectionVisible ?
                <Box align="center" >
                    {/*Field of Seedlings  */}
                    {selectedField.FieldType === 1 ? 
                    <>
                    <Box width={screenSize === "small" ? "100%" : screenSize === "xlarge" ? "70%" : "80%" }>
                        <Box direction="row-responsive" gap="small"  align="end" justify="between" >
                            <Box  margin={{vertical: "small"}} width="100%" >
                                <Text  style={labelStyle}> Select parents: </Text>                           
                                <Box direction="row-responsive" gap="xxsmall" align="center" justify="between" >
                                    <Box pad={{vertical: "xxsmall"}} width={screenSize === "small" ? "100%" : "300px" } > 
                                        <Text  size="small" weight="bold" > Mother: </Text>
                                        <Select
                                            value={mother.pId}
                                            valueKey={{key: "pId", reduce: true }}
                                            labelKey="pId"
                                            placeholder="Select Mother..."
                                            style={{padding: "5px 0 5px 10px"}} 
                                            options={mothersList}       
                                            onChange={({option}) => {option === undefined ? 
                                                    setMother({  
                                                        Id: '00000000-0000-0000-0000-000000000000',
                                                        pId:'',
                                                    })
                                                    : setMother(option)}}                                
                                            emptySearchMessage={"No Parent Available"} 
                                            clear                                  
                                        />
                                    </Box> 
                                    <Box pad={{vertical: "xxsmall"}} 
                                        width={screenSize === "small" ? "100%" : "300px" } 
                                        >      
                                        <Text  size="small" weight="bold"  color="neutral-3" > Father: </Text>                                        
                                        <Select
                                            value={father.pId}
                                            valueKey={{key: "pId", reduce: true }}
                                            labelKey="pId"
                                            placeholder="Select Father..."
                                            style={{padding: "5px 0 5px 10px"}}  
                                            options={fathersList}                               
                                            onChange={({option}) => {option === undefined ? 
                                                    setFather({  
                                                        Id: '00000000-0000-0000-0000-000000000000',
                                                        pId:'',
                                                    })
                                                    : setFather(option)}}
                                            clear={{ position: 'top' }} 
                                        /> 
                                    </Box>  
                                </Box> 
                            </Box>
                            
                            <Box margin={{horizontal: "small"}} width= "200px" minWidth= "200px">
                                <Box pad="xxsmall" width= "160px"  minWidth= "160px">

                                    <Button     
                                        style={{color: "#ffffff"}}    // for label
                                        color="#A2423D"                                 
                                        primary                            
                                        label="uproot seedlings"
                                        onClick={() =>  
                                            isUprootSeedlings()} 
                                    />

                                </Box> 
                            </Box>

                            <Box margin={{horizontal: "small"}} width= "200px">
                                <Box pad="xxsmall" width= "160px">

                                    <Button         
                                        style={{color: "#ffffff"}}                               
                                        primary                            
                                        label="add seedlings"
                                        onClick={() =>  
                                            onOpenAddNewSeedlingWindow()} 
                                    />

                                </Box> 
                            </Box>
                        </Box>                    
                    </Box>

                    <Box height='550px' width='1100px' align="center"  border>                                  

                        {(seedlingRow !== '' && seedlingRow !== 0 && Number(seedlingRow) >= selectedField.RowFrom && Number(seedlingRow) <= selectedField.RowTo) && 
                        <Box flex={true} align='center' background='light-1' overflow='auto'>
                            <Box flex={false} background='white'>   
                            {/* {   console.log('seedlingsArr -->>  ', seedlingsArr)}  */}
                                <Field plants={seedlingsArr} setChosen={setChosenVineInfo} setShow={setShowSeedlingOnField} 
                                selectedRow={seedlingRow} selectedCol={seedlingColumn} selectedField={selectedField}
                                strongPlantImage="Grape_bush.png"  weakPlantImage="Grape_bush.png" secondaryImage="Grape_station.png" 
                                mother={mother.Id} father={father.Id} 
                                newSeedlingLocations={newSeedlingLocations} setNewSeedlingLocations={setNewSeedlingLocations}
                                openAddNewSeedlingWindow={setOpenAddNewSeedlingWindow}   onCheckedChange={addSeedlingToSelected}
                                />
                            </Box>
                        </Box>                                   
                        }
                       
                        {/* <Box flex={true} align='center' background="#FEF2E8" width='100%' border={{ color: "#f0869c", size: "small" }} >
                            <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line', fontSize: '24px', color: '#f0869c', fontStyle: "italic"}}><strong>The entered Row is not suitable for seedlings!</strong></span></Text>
                        </Box>  */}
                      
                    </Box>
                   
                    </>
                    :
                    <Box width='96%' alignSelf="center" margin="small" pad="small" height="550px" >
                        <Image
                            alignSelf="center"
                            src="Grape.png" 
                            // src="Grape_sukka.png"
                            fit="cover"
                            opacity="medium"                          
                        />
                    </Box>
                    } 

                    {showSeedlingOnField && chosenVineInfo !== null &&
                    <Box width={screenSize === "xxsmall" ? "100%" : "60%" }>
                        <Layer >
                            <SeedlingOnField plant={chosenVineInfo} setPlantInfo={setChosenVineInfo}  
                                setShow={setShowSeedlingOnField} 
                                reRender={reRender}// size={screenSize}
                                parentsList={parentsList}
                                setChosenOption={setChosenOption}
                                onCreateNewStation={onCreateNewStation} 
                                setSeedlingRow={setSeedlingRow}
                                seedlingRow={seedlingRow}
                                selectedField={selectedField}
                                seedlingId={seedlingId} seedlingYear={seedlingYear}
                                setPostharvestButton={setPostharvestButton}
                                setStationTreatments={setStationTreatments}
                                onStationPopupClose={onCloseStationPopup}
                                seedlingsArr={seedlingsArr}
                                setSeedlingsArr={setSeedlingsArr}
                                deleteDisqualReason={deleteDisqualReason}
                                />
                        </Layer>
                    </Box>
                    }

                    {openAddNewSeedlingWindow && 
                    <AddNewSeedling 
                        parentsList={parentsList}
                        loadParents={loadParents}
                        onClose={onCloseAddNewSeedlingWindow} 
                        newSeedlingLocations={newSeedlingLocations}
                        setNewSeedlingLocations={setNewSeedlingLocations}
                        reRender={reRender}
                        >
                    </AddNewSeedling>}                 
                </Box> 
                :
                <>
                 <Box width="96%"  direction='column' alignSelf="center" align="center" margin="small" height={screenSize === "xsmall" ? "80%" : "680px"  } style = {{paddingTop: '150px'}}>
                    <Box  alignSelf="center"  direction="row"  margin="small" >
                    <Image
                        alignSelf="center"
                        src={screenSize === "xsmall" || screenSize === "small" ? "Grape_bush.png" : "Grape_sukka.png"   }
                        fit="cover" 
                        size="contain" 
                        opacity="0.1" 
                    />
                    </Box>
                </Box> 
                </>
                }
                </Box>
)}

            {chosenOption === "Stations" && (
            <Box align="center">
                {/* Open station without seedling  */}
                {openStationPopup && 
                <StationPopup onClose={onCloseStationPopup} 
                    parentsList={parentsList}
                    loadParents={loadParents}
                    setPostharvestButton={setPostharvestButton}
                    setStationTreatments={setStationTreatments}
                    selectedField={{  
                        Id: '00000000-0000-0000-0000-000000000000', 
                        RowFrom: 0,
                        RowTo: 0,
                        FieldName: '',
                        FieldType: 0,
                        VinesOnRow: 0,
                        Description: "",                    
                    }} 
                    onCreateNewStation={onCreateNewStation}                    
                    reRender={reRender}
                    >
                </StationPopup>} 


                {selectedStation.Id !== '00000000-0000-0000-0000-000000000000' ? 
                <>
                    {stationsListVisible && (
                    <Box align="center" >
                        <Box  direction="row-responsive"> 
                            <Box pad={{horizontal: "small"}} >   
                                <StationList 
                                    stations={activeStationsList} 
                                    stationChange={changeSelectedStation}
                                    selectedStation={selectedStation}
                                    currentPage={selectedStation}
                                    visibleOnScreen={numOfVisibleStations} />
                            </Box> 

                            
                            <Box justify="evenly" direction="row-responsive">  
                                <Box  direction="row-responsive" align="center" width="300px" >
                                    <Box  wrap={true} >
                                        <Text  size="medium" weight="bold" margin="small" >Number of stations <br/>visible in the list</Text>
                                    </Box>
                                    <Box width= "60px">
                                        <TextInput
                                            type="number"
                                            value={numOfVisibleStations}
                                            size="medium"  
                                            margin={{vertical: "xlarge"}} 
                                            style={{ padding: "5px 0 5px 10px"}} 
                                            onChange={({ target: { value } }) => {
                                                setNumOfVisibleStations( Math.min(Math.max(Number(value),1),activeStationsList.length));
                                            }}                     
                                        />
                                    </Box>
                                </Box>  
                            </Box>
                        </Box>

                        <Box  direction="row-responsive"  align="center" width="500px"  min-width="500px" >
                            <Box>
                                <Text  size="medium" weight="bold" margin="small" style={{whiteSpace: "nowrap"}}>Choose a station:</Text>
                            </Box>                        
                            <Box direction="row" width='300px' border= {{color: "brand"}}
                                onClick={()=> {
                                    onOpenParentsListWindow();}} 
                            >

                                <TextInput                            
                                    hoverIndicator={true}
                                    focusIndicator={false}
                                    placeholder="Search..."                  
                                    value={searchInput}
                                    style={{ padding: "5px 0 5px 10px"}}                
                                    plain   
                                    // onChange={(e) => searchItems(e.target.value)}                                                         
                                    /> 
                                    <Search style={{ margin:"5px"}}  color="brand" />
                            </Box>        
                        </Box>
                    </Box>            
                    )}

                    {showTreatments &&
                    <TreatmentsListByStation
                        station = {selectedStation}
                        stationStartRow = {stationStartRow}
                        allStationTreatments={allStationTreatments}
                        finishScionTreatment={finishScionTreatment}
                        setShowTreatments = {setShowTreatments}
                        openTreatment={openTreatment}
                        bestTreatmentNum={bestTreatmentNum}
                        setBestTreatmentNum={setBestTreatmentNum}
                        bestTreatmentBy={bestTreatmentBy}
                        setBestTreatmentBy={setBestTreatmentBy}
                        deleteDisqualReason={deleteDisqualReason}
                        loadAllTreatmentsByStation={loadAllTreatmentsByStation}
                        showTreatmentsMultiYearSummary={showTreatmentsMultiYearSummary}
                        setShowTreatmentsMultiYearSummary={setShowTreatmentsMultiYearSummary}
                    />}
                    {addTreatmentsPopupOpen && 
                    <AddScionsToTreatmentPopup                         
                        station = {selectedStation}
                        selectedScionList = {selectedScionList}
                        setShowTreatments = {setShowTreatments} 
                        OpenTreatmentSheet={OpenTreatmentSheet}
                        setAddTreatmentsPopupOpen={setAddTreatmentsPopupOpen}
                        loadAllTreatmentsByStation={loadAllTreatmentsByStation}
                        loadTreatmentList={loadTreatmentList}
                        addScionToSelected={addScionToSelected}
                        loadScions={loadScions}
                    />
                    }

                    {/* Field of Scions  */}          
                    {scionsArr.length > 0 ? 
                    <Box align="center" round="medium">
                        <Box wrap flex={false} align="center" round="medium" overflow="auto" background="light-2"  margin={{vertical: "small"}} >
                            {/* Station name */}
                            <Box direction="row-responsive"  align="end" alignSelf="center" margin={{top: "medium"}}>
                                <Box margin={{vertical: "xxsmall"}}>
                                    <Text  size="large" weight="bold" >Selected station: </Text>
                                </Box>
                                {/* {console.log('selectedStation !!!  >>> ', selectedStation)} */}
                                <Text style={StationNameStyle} >
                                    &nbsp;&nbsp;&nbsp;&nbsp;{selectedStation.DisplayName && selectedStation.DisplayName.length > 20 ? (selectedStation.DisplayName).substring(0, 20) : selectedStation.DisplayName}                                  
                                </Text> 
                            </Box> 
                            
                            {/* Station data */}
                            <Box direction="row-responsive" alignSelf="center" justify="center"
                                    style={{ position: "relative",}} >

                                <Box direction="row-responsive" border >    
                                {/* <DropdownMenu label="My Actions" menuItems={menuItems} /> */}
                                <ExpandingButtonsMenu aria-hidden={showTreatments} buttons={buttons} direction={screenSize <= "medium" ? "column" : "row"} />
                                </Box>

                                <Box direction="row-responsive" pad="small" border  height="250px">
                                    <Box  margin="xsmall" width='220px' gap="xxsmall">


                                        <Box direction="row"  min-width="small">
                                            <Box  min-width="100px" justify="end"   >
                                                <Text  style={StationLabelStyle} >From seedling: </Text>
                                            </Box>
                                                <Text style={textStyle} >
                                                    &nbsp;&nbsp;
                                                    {isNaN(selectedStation.SeedlingRow) || isNaN(selectedStation.SeedlingColumn) ? 
                                                        '' :
                                                        `${selectedStation.SeedlingRow} - ${selectedStation.SeedlingColumn}`}
                                                            
                                                </Text> 
                                        </Box>                                
                                        <Box direction="row"  min-width="small" >
                                            <Box  wrap={true} justify="end"  width="80px">
                                                <Text style={StationLabelStyle} >Rootstock: </Text>
                                            </Box>
                                                <Text style={textStyle} >
                                                    &nbsp;{selectedStation.Rootstock.length > 20 ? (selectedStation.Rootstock).substring(0, 20) : selectedStation.Rootstock}                                  
                                                </Text> 
                                        </Box>                                        

                                        <Box direction="row"  width="small"   min-width="small">
                                            <Box  wrap={true} justify="end" width="70px">
                                                <Text  style={StationLabelStyle} >Mother: </Text>
                                            </Box>
                                            <Text style={textStyle} >
                                                &nbsp;{selectedStation.Mother.length > 20 ? (selectedStation.Mother).substring(0, 20) : selectedStation.Mother}                                  
                                            </Text>  
                                        </Box>  
                                        <Box direction="row"  width="small"   min-width="small" >                           
                                            <Box  wrap={true} justify="end" width="70px">
                                                <Text  style={StationLabelStyle} >Father: </Text>
                                            </Box>
                                            <Text style={textStyle} >
                                                &nbsp;{selectedStation.Father.length > 20 ? (selectedStation.Father).substring(0, 20) : selectedStation.Father}                                  
                                            </Text> 
                                        </Box> 
                                        <Box direction="row"  width="small"   min-width="small">
                                            <Box  wrap={true} justify="end" width="100px">
                                                <Text  style={StationLabelStyle} >Planting Year: </Text>
                                            </Box>
                                            <Text style={textStyle} >
                                                &nbsp;{selectedStation.Year}                                  
                                            </Text> 
                                        </Box>
                                        <Box direction="row"  width="small"   min-width="small">
                                            <Box  wrap={true} justify="end" width="80px">
                                                <Text  style={StationLabelStyle} >Fruit color: </Text>
                                            </Box>
                                            <Text style={textStyle} >
                                                &nbsp;{getLabelByIndex('FruitColor',selectedStation.FruitColor)} 
                                            </Text>  
                                        </Box>  


                                    </Box>               

                                </Box>

    
                                {/* <Box border> */}
                                <Box  pad="small" border height="250px">
                                    <Box margin={{vertical: "xxsmall"}} alignSelf="center">           
                                        <Text  size="medium" weight="bold"  color="neutral-3" margin={{vertical: "xsmall"}}> Phenological stages for </Text> 
                                        <Box  direction="row">
                                            <Box margin={{horizontal: "small"}}>
                                                <Box flex={false} pad="xsmall" direction="row">
                                                    {arrow('prev', handleChange)}
                                                    <Box width="80px" >
                                                    <TextInput
                                                        type="number"                        
                                                        value={yearValue}
                                                        style={{ padding: "1px 0 1px 15px"}} 
                                                        onChange={(event) => 
                                                            onChangeYear(event.target.value)                            
                                                        }
                                                    />  
                                                    </Box>
                                                    {arrow('next', handleChange)}
                                                </Box>
                                            </Box>
                                            {/* <Text  size="medium" weight="bold"  color="neutral-3" margin={{vertical: "xsmall"}}> year</Text>   */}
                                        </Box>  
                                    </Box>


                                    <Box margin={{horizontal: "small"}} border></Box> 

                                    <Box direction="row-responsive">
                                        <Box  margin="xsmall" width='250px'>
                                            <Box direction="row"  align="end" min-width="small" >
                                                <Box  wrap={false}  width="80px" >
                                                    <Text  style={StationLabelStyle} >Bud break: </Text>
                                                </Box>
                                                <Box width="120px" style={{ background: '#33333310'}}>
                                                    <Text style={textStyle} >
                                                        &nbsp;&nbsp;&nbsp;&nbsp;{phenologicalPhasesByStation.BudBreakDate === '1900-01-01T00:00:00.000Z'? '' : convertDateToDisplayformat(phenologicalPhasesByStation.BudBreakDate)}                                
                                                    </Text> 
                                                </Box>
                                                <Box margin={{horizontal: '5px'}} hoverIndicator border>
                                                    <Edit size="18px" style={{ margin:"2px"}}  color="brand" 
                                                        onClick={()=> {
                                                            setChangePhenologicalPhaseMsg('Bud break date will be changed to new');
                                                            setShowChangePhenologicalPhase(true);
                                                            setPhenologicalPhaseDateToChange({Phase: 1, PhaseId: phenologicalPhasesByStation.BudBreakId, DateValue: phenologicalPhasesByStation.BudBreakDate});
                                                        }}

                                                        />                                            
                                                </Box>                                        
                                            </Box>

                                            <Box direction="row"   align="end" min-width="small" >
                                                <Box width="80px">   
                                                    <Text  style={StationLabelStyle}>Flowering: </Text>
                                                </Box>
                                                <Box width="120px" style={{ background: '#33333310'}}>
                                                    <Text style={textStyle}>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;{phenologicalPhasesByStation.FloweringDate === '1900-01-01T00:00:00.000Z'? '' : convertDateToDisplayformat(phenologicalPhasesByStation.FloweringDate)}
                                                    </Text> 
                                                </Box>
                                                <Box margin={{horizontal: '5px'}} hoverIndicator border>
                                                    <Edit size="18px" style={{ margin:"2px"}}  color="brand" 
                                                        onClick={()=> {
                                                            setChangePhenologicalPhaseMsg('Flowering date will be changed to new');
                                                            setShowChangePhenologicalPhase(true);
                                                            setPhenologicalPhaseDateToChange({Phase: 2, PhaseId: phenologicalPhasesByStation.FloweringId, DateValue: phenologicalPhasesByStation.FloweringDate});

                                                        }}/>
                                                </Box>
                                            </Box> 


                                            <Box direction="row"  align="end" min-width="small" >
                                                <Box width="80px">
                                                    <Text  style={StationLabelStyle} >Veraison: </Text>
                                                </Box>
                                                <Box width="120px" style={{ background: '#33333310'}}>
                                                    <Text style={textStyle} >
                                                        &nbsp;&nbsp;&nbsp;&nbsp;{phenologicalPhasesByStation.VeraisonDate === '1900-01-01T00:00:00.000Z'? '' : convertDateToDisplayformat(phenologicalPhasesByStation.VeraisonDate)}                                
                                                    </Text> 
                                                </Box>
                                                <Box margin={{horizontal: '5px'}} hoverIndicator border>
                                                    <Edit size="18px" style={{ margin:"2px"}}  color="brand" 
                                                        onClick={()=> {
                                                            setChangePhenologicalPhaseMsg('Veraison date will be changed to new');
                                                            setShowChangePhenologicalPhase(true);
                                                            setPhenologicalPhaseDateToChange({Phase: 3, PhaseId: phenologicalPhasesByStation.VeraisonId, DateValue: phenologicalPhasesByStation.VeraisonDate});
                                                        }}/>
                                                </Box>
                                            </Box>

                                            <Box direction="row"   align="end"  min-width="small" >
                                                <Box width="80px">
                                                    <Text style={StationLabelStyle}>Ripeness: </Text>
                                                </Box>
                                                <Box width="120px" style={{ background: '#33333310', paddingTop: '0px'}} >
                                                    <Text style={textStyle} >
                                                        &nbsp;&nbsp;&nbsp;&nbsp;{phenologicalPhasesByStation.RipenessDate === '1900-01-01T00:00:00.000Z'? '' : convertDateToDisplayformat(phenologicalPhasesByStation.RipenessDate)}                                
                                                    </Text> 
                                                </Box>
                                                <Box margin={{horizontal: '5px'}} hoverIndicator border>
                                                    <Edit size="18px" style={{ margin:"2px"}}  color="brand" 
                                                        onClick={()=> {
                                                            setChangePhenologicalPhaseMsg('Ripeness date will be changed to new');
                                                            setShowChangePhenologicalPhase(true);
                                                            setPhenologicalPhaseDateToChange({Phase: 4, PhaseId: phenologicalPhasesByStation.RipenessId, DateValue: phenologicalPhasesByStation.RipenessDate});
                                                        }}/>
                                                </Box>
                                            </Box>

                                        </Box>

                        
                                    </Box>
                                </Box> 

                                {showChangePhenologicalPhase && 
                                <ChangePhenologicalPhaseDate msg={changePhenologicalPhaseMsg} onClose={setShowChangePhenologicalPhase} 
                                    phenologicalPhaseDateToChange={phenologicalPhaseDateToChange}
                                    onConfirm={insertPhenologicalPhase}
                                    />
                                }
                            </Box>
                            {/* end of Station data */}

                            {showStationCharacteristics && 
                            <StationCharacteristicsPopup onClose={setShowStationCharacteristics} 
                                station = {selectedStation}
                                loadActiveStations={loadActiveStations}
                                setSelectedStation={setSelectedStation}
                                />
                            }

                            {/* combo for treatments on station */}
                            {stationTreatments.length > 0 &&          
                            <Box pad={{vertical: "xxsmall"}}  margin= "small" align="center" justify="center" direction="row-responsive" >
                                {(allStationTreatments.length > 0) && 
                                <Box width="400px" direction="row-responsive" pad="xxsmall"  align="center" justify="around">
                                    <Text  size="medium" weight="bold"  color="neutral-3" margin= "xsmall"> Display scions by: </Text>
                                    <Box pad={{horizontal: "small"}} direction="row-responsive" align="center"> 
                                        <Box width="200px" > 
                                            <Select
                                                value={selectedTreatment.Name}
                                                valueKey={{key: "Name", reduce: true }}
                                                labelKey="Name"
                                                placeholder="Select Treatment..."
                                                style={{padding: "5px 0 5px 10px"}} 
                                                options={treatmentsList}        
                                                onChange={({option}) => {option === undefined ? 
                                                        setSelectedTreatment({  
                                                            Id: '0',
                                                            Name:'',
                                                        })
                                                        : setSelectedTreatment(option)}}                                
                                                emptySearchMessage={"No Treatment Available"} 
                                                clear                                  
                                            />
                                        </Box> 
                                    </Box>  
                                </Box> 
                                }
                            </Box>
                            }

                            {/* {showStationButtons()} */}

                            {showTreatmentsMultiYearSummary &&
                            <StationMultiYearSummary 
                                station = {selectedStation}
                                openTreatment = {openTreatment}
                                onClose={() => setShowTreatmentsMultiYearSummary(false)}
                                />
                            }

                            {/* field */}
                            <Box  direction="row-responsive" alignSelf="center" margin="small">
                                <Field plants={scionsArr} setChosen={setChosenVineInfo} setShow={setShowScionOnField} 
                                selectedRow={''} selectedCol={''}   onScionClick={onScionClick} onCheckedChange={addScionToSelected}
                                strongPlantImage="Grape_station.png" weakPlantImage="Grape_station.png" secondaryImage="Grape_bush.png" 
                                selectedTreatment={selectedTreatment.Id} 
                                />
                            </Box>
                        </Box>
                    </Box>
                    :
                    <Box borderwidth='96%' alignSelf="center" margin="small" pad="small" height="350px" >
                        <Image
                            alignSelf="center"
                            src="Grape.png" 
                            fit="cover"
                            size="contain"   
                            opacity="medium"                          
                        />
                    </Box>                
                    }

                    {showScionOnField && chosenVineInfo !== null &&
                    <Box  width={screenSize === "xxsmall" ? "100%" : "60%" } >
                        <Layer >
                            <ScionOnField plant={chosenVineInfo} setPlantInfo={props.setPlantInfo}  setShow={setShowScionOnField} 
                                rootstockList={rootstockList} reRender={reRender}
                                activeStationsList={activeStationsList}
                                seedlingId={seedlingId} seedlingYear={seedlingYear}
                                selectedField={selectedField} selectedStation={selectedStation}
                            />
                        </Layer>
                    </Box>
                    }
                </>
                :
                <Box width="96%"  direction='column' alignSelf="center" align="center" margin="small" style = {{paddingTop: '100px'}}>
                    <Box  alignSelf="center" width="20%"  direction="row"  margin="small" >
                    {/* <Text  >size: {screenSize} </Text> */}
                        <Image
                            alignSelf="center"
                            src="Grape_station.png"
                            fit="cover"  
                            opacity="0.1"                          
                        />
                    </Box>
                </Box>}
                
            </Box> 
            )}

            {/* Show CultivarDetails Modal */}
            {showCultivarDetails && 
                <Layer
                id="alertmsg"
                position="center"
                modal
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                }}
            >
                <Box 
                    overflow='auto'
                    pad="small" 
                    gap="small" 
                    width="large"  
                    background="light-3"  
                    border={{ color: "brand"}}
                    style={{
                        position: 'relative',
                        margin: 'auto', // Center horizontally and vertically
                    }}
                >            
                    <CultivarDetails
                        cultivar={selectedCultivar} // Pass the selected cultivar to CultivarDetails 
                        onClosePopup={() => {
                            setSelectedStation(selectedStation);
                            reRender(); // Trigger re-render of base component                        
                            setShowCultivarDetails(false); // Close modal
                        }} 
                        createFromStation={true}
                        loadCultivarsList={loadActiveStations}
                        key={reRenderField} // Add a key prop to force re-render
                        // reRender={reRender}
                        />
                    </Box>   
                </Layer>                        
            } 
        </Box> 
        )}
        </ResponsiveContext.Consumer>
        </Form>   
    );
};

export default ExistingEvaluation;
